<template>
  <div class="rsvp-report-box">
    <div class="rsvp-report">
      <div class="form-group">
        <div class="instruction">Please select a start and end date:</div>
        <div class="row expanded filter-date">
          <div class="small-4 column padding-R select-date">
            <div class="date-input">
              <label>Filter:</label>
              <select v-model="dateType">
                <option value="bookingTime">Booking Date</option>
                <option value="pickupTime">Pickup Date</option>
                <option value="completeTime">Completed Date</option>
                <option value="cancelTime">Canceled Date</option>
              </select>
            </div>
          </div>
          <div class="small-4 column padding-R">
            <div class="date-input">
              <label>Start Date:</label>
              <datepicker class="datepicker" v-model="from" format="MMMM dd, yyyy" :highlighted="highlightedDates"></datepicker>
            </div>
          </div>
          <div class="small-4 column padding-L">
            <div class="date-input">
              <label>End Date:</label>
              <datepicker class="datepicker end-date" v-model="to" format="MMMM dd, yyyy" :highlighted="highlightedDates"></datepicker>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="list-box">
      <div class="rsvp-report">
        <!-- <div class="title">Please fill up the form:</div> -->
        <div class="form-group">
          <div class="download-type">
            <label :class="{'pdf':true, 'has-error':formatError}">
              <input type="checkbox" name="downloadType" v-model="pdfChecked"
                @click="formatCheck"/>
              PDF
            </label>
            <label :class="{'csv':true, 'has-error':formatError}">
              <input type="checkbox" name="downloadType" v-model="csvChecked"
                @click="formatCheck"/>
              CSV
            </label>
          </div>
          <div class="instruction">Please select the reports to generate:</div>
          <div class="row expanded reports">
            <div :class="['small-12 column report', reportStatus.rsvpSummary, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.rsvpSummary" />
                <span>{{ reportLabel('rsvpSummary') }}</span>
              </label>
              <select :class="{'disabled':!selectedReports.rsvpSummary}"
                :disabled="!selectedReports.rsvpSummary" v-model="selectedSummary">
                <option v-for="status in summaryReportStatus" :value="status.value"
                  :disabled="disableOption('rsvpSummary', status.value)">{{ status.label }}</option>
              </select>
            </div>
            <div :class="['small-12 column report', reportStatus.rsvpSummaryWeekly, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.rsvpSummaryWeekly" />
                <span>{{ reportLabel('rsvpSummaryWeekly') }}</span>
              </label>
            </div>
            <div :class="['small-12 column report', reportStatus.rsvpByDate, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.rsvpByDate" />
                <span>{{ reportLabel('rsvpByDate') }}</span>
              </label>
              <select :class="{'disabled':!selectedReports.rsvpByDate}"
                :disabled="!selectedReports.rsvpByDate" v-model="selectedDetailed">
                <option v-for="status in detailedReportStatus" :value="status.value"
                  :disabled="disableOption('rsvpByDate', status.value)">{{ status.label }}</option>
              </select>
            </div>
            <div :class="['small-12 column report', reportStatus.rsvpByRefund, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.rsvpByRefund" />
                <span>{{ reportLabel('rsvpByRefund') }}</span>
              </label>
            </div>
            <div :class="['small-12 column report', reportStatus.rsvpByDriver, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.rsvpByDriver" />
                <span>{{ reportLabel('rsvpByDriver') }}</span>
              </label>
            </div>
            <div :class="['small-12 column report', reportStatus.rsvpByDriverFare, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.rsvpByDriverFare" />
                <span>{{ reportLabel('rsvpByDriverFare') }}</span>
              </label>
            </div>
            <div :class="['small-12 column report', reportStatus.rsvpByServiceType, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.rsvpByServiceType" />
                <span>{{ reportLabel('rsvpByServiceType') }}</span>
              </label>
            </div>
            <div :class="['small-12 column report', reportStatus.rsvpByAirport, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.rsvpByAirport" />
                <span>{{ reportLabel('rsvpByAirport') }}</span>
              </label>
            </div>
            <div :class="['small-12 column report', reportStatus.rsvpByAirportDepArr, {'processing':pdf.loading}]" v-if="airports.length">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.rsvpByAirportDepArr" />
                <span>{{ reportLabel('rsvpByAirportDepArr') }}</span>
              </label>
              <select :class="{'disabled':!selectedReports.rsvpByAirportDepArr}"
                :disabled="!selectedReports.rsvpByAirportDepArr" v-model="selectedAirport">
                <option value="0">Please select airport</option>
                <option v-for="airport in airports" :value="airport.geofenceId">
                  {{ airport.airportCode }} - {{ airport.description }}
                </option>
              </select>
            </div>
            <div :class="['small-12 column report', reportStatus.rsvpByGroup, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.rsvpByGroup" />
                <span>{{ reportLabel('rsvpByGroup') }}</span>
              </label>
            </div>
            <div :class="['small-12 column report', reportStatus.rsvpByPayment, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.rsvpByPayment" />
                <span>{{ reportLabel('rsvpByPayment') }}</span>
              </label>
            </div>
            <div :class="['small-12 column report', reportStatus.rsvpByTripStatus, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.rsvpByTripStatus" />
                <span>{{ reportLabel('rsvpByTripStatus') }}</span>
              </label>
            </div>
            <div :class="['small-12 column report', reportStatus.rsvpByBrands, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.rsvpByBrands" />
                <span>{{ reportLabel('rsvpByBrands') }}</span>
              </label>
            </div>
            <div :class="['small-12 column report', reportStatus.variance, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.variance" />
                <span>{{ reportLabel('variance') }}</span>
              </label>
            </div>
            <div :class="['small-12 column report', reportStatus.rsvpSummaryCorporate, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.rsvpSummaryCorporate" />
                <span>{{ reportLabel('rsvpSummaryCorporate') }}</span>
              </label>
            </div>
            <div :class="['small-12 column report', reportStatus.rsvpCorporate, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.rsvpCorporate" />
                <span>{{ reportLabel('rsvpCorporate') }}</span>
              </label>
            </div>
            <div :class="['small-12 column report', reportStatus.rsvpTerminal, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.rsvpTerminal" />
                <span>{{ reportLabel('rsvpTerminal') }}</span>
              </label>
            </div>
            <div :class="['small-12 column report', reportStatus.creditConverted, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.creditConverted" />
                <span>{{ reportLabel('creditConverted') }}</span>
              </label>
            </div>
            <div :class="['small-12 column report', reportStatus.bySector, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.bySector" />
                <span>{{ reportLabel('bySector') }}</span>
              </label>
              <!-- <select :class="{'disabled':!selectedReports.bySector}"
                :disabled="!selectedReports.bySector" v-model="bySectorStatus">
                <option value="">All</option>
                <option value="UPCOMING">UPCOMING</option>
                <option value="COMPLETED">COMPLETED</option>
              </select> -->
            </div>
          </div>
        </div>

        <transition name="slide-down">
          <div class="error" v-show="error.show">
            <span v-show="!!error.message">{{ error.message }}</span>
            <ul v-show="error.empty.length">
              <li>Empty Result:</li>
              <li v-for="empty in error.empty">- {{ empty }}</li>
            </ul>
          </div>
        </transition>
        <a v-bind:class="{ 'button cta success small block': true, disabled: pdf.loading }"
          href="javascript:;" @click="startProcess">
          <i class="fa fa-spinner fa-spin" v-show="pdf.loading"></i>
          <span v-show="!pdf.loading">Generate and Download Report</span>
        </a>
      </div>
    </div>

    <div id="pdf-view" :class="[pdf.class]">
      <div v-for="(pageData, pageIndex) in pdf.table.data" :class="['page', pageIndex]">
        <div class="title">{{ pdf.title }}</div>
        <div class="date-range">{{ pdf.date }}</div>
        <table>
          <thead>
            <tr v-if="!isRsvpSummaryWeekly && !isRsvpTerminal">
              <th v-for="label in pdf.table.label" v-html="label"></th>
            </tr>
            <tr v-if="isRsvpSummaryWeekly" class="table-heading">
              <th></th>
              <th v-if="pdf.table.extra[pageIndex].day1" colspan="2"
                v-html="weeklySummaryLabel(pdf.table.extra[pageIndex].day1.value)"></th>
              <th v-if="pdf.table.extra[pageIndex].day2" colspan="2"
                v-html="weeklySummaryLabel(pdf.table.extra[pageIndex].day2.value)"></th>
              <th v-if="pdf.table.extra[pageIndex].day3" colspan="2"
                v-html="weeklySummaryLabel(pdf.table.extra[pageIndex].day3.value)"></th>
              <th v-if="pdf.table.extra[pageIndex].day4" colspan="2"
                v-html="weeklySummaryLabel(pdf.table.extra[pageIndex].day4.value)"></th>
              <th v-if="pdf.table.extra[pageIndex].day5" colspan="2"
                v-html="weeklySummaryLabel(pdf.table.extra[pageIndex].day5.value)"></th>
              <th v-if="pdf.table.extra[pageIndex].day6" colspan="2"
                v-html="weeklySummaryLabel(pdf.table.extra[pageIndex].day6.value)"></th>
              <th v-if="pdf.table.extra[pageIndex].day7" colspan="2"
                v-html="weeklySummaryLabel(pdf.table.extra[pageIndex].day7.value)"></th>
            </tr>
            <tr v-if="isRsvpSummaryWeekly" class="table-heading">
              <th>Time period</th>
              <th v-if="!!pdf.table.extra[pageIndex].day1">PAX</th>
              <th v-if="!!pdf.table.extra[pageIndex].day1">RSVP</th>
              <th v-if="!!pdf.table.extra[pageIndex].day2">PAX</th>
              <th v-if="!!pdf.table.extra[pageIndex].day2">RSVP</th>
              <th v-if="!!pdf.table.extra[pageIndex].day3">PAX</th>
              <th v-if="!!pdf.table.extra[pageIndex].day3">RSVP</th>
              <th v-if="!!pdf.table.extra[pageIndex].day4">PAX</th>
              <th v-if="!!pdf.table.extra[pageIndex].day4">RSVP</th>
              <th v-if="!!pdf.table.extra[pageIndex].day5">PAX</th>
              <th v-if="!!pdf.table.extra[pageIndex].day5">RSVP</th>
              <th v-if="!!pdf.table.extra[pageIndex].day6">PAX</th>
              <th v-if="!!pdf.table.extra[pageIndex].day6">RSVP</th>
              <th v-if="!!pdf.table.extra[pageIndex].day7">PAX</th>
              <th v-if="!!pdf.table.extra[pageIndex].day7">RSVP</th>
            </tr>
            <tr v-if="isRsvpTerminal" class="table-heading">
              <th>Time period</th>
              <th v-for="(terminal, i) in pdf.table.extra[pageIndex]" :key="i">T {{ i.substring(8) }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in pageData" :key="index">
              <td v-for="(value, i) in data" :class="[i]" :key="i">{{ value }}</td>
            </tr>

            <tr v-if="isRsvpByDate || isRsvpByRefund"
              :class="{'subtotal':true, 'no-border':currentPage(pageIndex) == totalPage}">
              <td :colspan="[isRsvpByRefund ? '8' : '9']" class="total-count">Group Subtotal ({{ pdf.table.extra[pageIndex].count }})</td>
              <td class="total-pax">{{ pdf.table.extra[pageIndex].pax }}</td>
              <td class="total-fare">${{ pdf.table.extra[pageIndex].fare }}</td>
              <td class="total-refund" v-if="isRsvpByRefund">${{ pdf.table.extra[pageIndex].refund }}</td>
              <td v-if="['completed', 'canceled'].indexOf(selectedDetailed) === -1"></td>
              <td class="extraFee" v-show="(selectedDetailed === 'canceled' || dateType === 'cancelTime') && isRsvpByDate">${{ pdf.table.extra[pageIndex].cancelFee }}</td>
            </tr>
            <tr v-if="isRsvpByDate && currentPage(pageIndex) == totalPage" class="total">
              <td colspan="9" class="total-count">Report Total ({{ pdf.table.total.record }})</td>
              <td class="total-pax">{{ pdf.table.total.pax }}</td>
              <td class="total-fare">${{ pdf.table.total.fare }}</td>
              <td class="total-refund" v-if="isRsvpByRefund">${{ pdf.table.total.refund }}</td>
              <td v-if="['completed', 'canceled'].indexOf(selectedDetailed) === -1"></td>
              <td class="extraFee" v-show="selectedDetailed === 'canceled' && isRsvpByDate">${{ pdf.table.total.extraFee }}</td>
            </tr>
            <tr v-if="isRsvpByRefund && currentPage(pageIndex) == totalPage" class="total">
              <td colspan="8" class="total-count">Report Total ({{ pdf.table.total.record }})</td>
              <td class="total-pax">{{ pdf.table.total.pax }}</td>
              <td class="total-fare">${{ pdf.table.total.fare }}</td>
              <td class="total-refund" v-if="isRsvpByRefund">${{ pdf.table.total.refund }}</td>
              <td v-if="['completed', 'canceled'].indexOf(selectedDetailed) === -1"></td>
              <td class="extraFee" v-show="selectedDetailed === 'canceled' && isRsvpByDate">${{ pdf.table.total.extraFee }}</td>
            </tr>

            <tr v-if="(isRsvpSummary || isRsvpByDriver || isRsvpByDriverFare || isServiceReservations || isRsvpByGroup || isRsvpByTripStatus || isRsvpByBrands || isRsvpSummaryCorporate) && currentPage(pageIndex) == totalPage"
              class="total">
              <td>Total ({{ pdf.table.total.record }})</td>
              <td class="distance" v-if="isRsvpByDriver">{{ pdf.table.total.distance }}</td>
              <td class="rsvpCount">{{ pdf.table.total.rsvp }}</td>
              <td class="asap">{{ pdf.table.total.asap }}</td>
              <td class="web">{{ pdf.table.total.web }}</td>
              <td class="web">{{ pdf.table.total.admin }}</td>
              <td class="web">{{ pdf.table.total.app }}</td>
              <td class="web">{{ pdf.table.total.go }}</td>
              <td class="totalPax">{{ pdf.table.total.pax }}</td>
              <td class="avgPax">{{ pdf.table.total.avgPax }}</td>
              <td class="dutyHours" v-if="isDriverReservations">{{ pdf.table.total.dutyHours }}</td>
              <td class="totalFare">${{ pdf.table.total.fare }}</td>
              <td class="avgFare">{{ pdf.table.total.avgFare }}</td>
              <td class="avgFarePP">{{ pdf.table.total.avgFarePP }}</td>
              <td class="extraFee"
                v-show="(['canceled', 'promo', 'noshow'].indexOf(selectedSummary) > -1 && isRsvpSummary) || isDriverReservations">${{ pdf.table.total.extraFee }}</td>
              <td class="driverPercent" v-show="isDriverReservations">{{ pdf.table.total.percent }}</td>
            </tr>

            <tr v-if="isRsvpCorporate && currentPage(pageIndex) == totalPage"
              class="total">
              <td colspan="7" class="total-count">Total ({{ pdf.table.total.record }})</td>
              <td class="total-fare">${{ pdf.table.total.fare }}</td>
            </tr>

            <tr v-if="isAirportReservations && currentPage(pageIndex) == totalPage"
              class="total">
              <td>Total ({{ pdf.table.total.record }})</td>
              <td class="rsvpCount">{{ pdf.table.total.rsvp }}</td>
              <td class="asap">{{ pdf.table.total.asap }}</td>
              <td class="oneway">{{ pdf.table.total.oneway }}</td>
              <td class="roundtrip">{{ pdf.table.total.roundtrip }}</td>
              <td class="roundtripInstances">{{ pdf.table.total.roundtripInstances }}</td>
              <td class="totalRsvpInstances">{{ pdf.table.total.rsvpIsntances }}</td>
              <td class="onewayPercent">{{ pdf.table.total.onewayPercent }}%</td>
              <td class="roundtripPercent">{{ pdf.table.total.roundtripPercent }}%</td>
            </tr>

            <tr v-if="isRsvpSummaryWeekly" class="total">
              <td>Totals</td>
              <td v-if="pdf.table.extra[pageIndex].day1">{{ pdf.table.extra[pageIndex].day1.pax }}</td>
              <td v-if="pdf.table.extra[pageIndex].day1">{{ pdf.table.extra[pageIndex].day1.rsvp }}</td>
              <td v-if="pdf.table.extra[pageIndex].day2">{{ pdf.table.extra[pageIndex].day2.pax }}</td>
              <td v-if="pdf.table.extra[pageIndex].day2">{{ pdf.table.extra[pageIndex].day2.rsvp }}</td>
              <td v-if="pdf.table.extra[pageIndex].day3">{{ pdf.table.extra[pageIndex].day3.pax }}</td>
              <td v-if="pdf.table.extra[pageIndex].day3">{{ pdf.table.extra[pageIndex].day3.rsvp }}</td>
              <td v-if="pdf.table.extra[pageIndex].day4">{{ pdf.table.extra[pageIndex].day4.pax }}</td>
              <td v-if="pdf.table.extra[pageIndex].day4">{{ pdf.table.extra[pageIndex].day4.rsvp }}</td>
              <td v-if="pdf.table.extra[pageIndex].day5">{{ pdf.table.extra[pageIndex].day5.pax }}</td>
              <td v-if="pdf.table.extra[pageIndex].day5">{{ pdf.table.extra[pageIndex].day5.rsvp }}</td>
              <td v-if="pdf.table.extra[pageIndex].day6">{{ pdf.table.extra[pageIndex].day6.pax }}</td>
              <td v-if="pdf.table.extra[pageIndex].day6">{{ pdf.table.extra[pageIndex].day6.rsvp }}</td>
              <td v-if="pdf.table.extra[pageIndex].day7">{{ pdf.table.extra[pageIndex].day7.pax }}</td>
              <td v-if="pdf.table.extra[pageIndex].day7">{{ pdf.table.extra[pageIndex].day7.rsvp }}</td>
            </tr>

            <tr v-if="isRsvpTerminal" class="total">
              <td>Totals</td>
              <td v-for="(terminal, index) in pdf.table.extra[pageIndex]" :key="index">{{ terminal.rsvp }}</td>
            </tr>

            <tr v-if="isRsvpByAirportDepArr && currentPage(pageIndex) == totalPage" class="total">
              <td>Totals</td>
              <td class="departureRsvp">{{ pdf.table.total.departureRsvp }}</td>
              <td class="arrivalRsvp">{{ pdf.table.total.arrivalRsvp }}</td>
              <td class="totalRsvp">{{ pdf.table.total.totalRsvp }}</td>
              <td class="departurePax">{{ pdf.table.total.departurePax }}</td>
              <td class="arrivalPax">{{ pdf.table.total.arrivalPax }}</td>
              <td class="totalPax">{{ pdf.table.total.totalPax }}</td>
            </tr>

            <tr v-if="isRsvpByPayment" class="total">
              <td class="total-label">Totals</td>
              <td class="rsvp">{{ pdf.table.total.rsvp }}</td>
              <td class="pax">{{ pdf.table.total.pax }}</td>
              <td class="charged">${{ pdf.table.total.charged }}</td>
              <td class="gratuity">${{ pdf.table.total.gratuity }}</td>
            </tr>

            <tr v-if="isCreditConverted && currentPage(pageIndex) == totalPage" class="total">
              <td colspan="7" class="total-count">Total ({{ pdf.table.total.record }})</td>
              <td class="total-pax">{{ pdf.table.total.pax }}</td>
              <td class="total-fare">${{ pdf.table.total.fare }}</td>
              <td class="total-creditReceived">${{ pdf.table.total.creditReceived }}</td>
            </tr>

          </tbody>
        </table>
        <div class="page-count">page {{ currentPage(pageIndex) }} of {{ totalPage }}</div>
      </div>

      <div :class="['page', `page${Object.keys(pdf.table.data).length + 1}`]" v-if="Object.keys(pdf.table.data).length">
        <div class="title">{{ pdf.title }}</div>
        <div class="date-range">{{ pdf.date }}</div>
        <table>
          <thead>
            <tr v-if="!isRsvpSummaryWeekly && !isRsvpTerminal">
              <th v-for="label in pdf.table.label" v-html="label"></th>
            </tr>
            <tr v-if="isRsvpSummaryWeekly" class="table-heading">
              <th></th>
              <th v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day1" colspan="2"
                v-html="weeklySummaryLabel(pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day1.value)"></th>
              <th v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day2" colspan="2"
                v-html="weeklySummaryLabel(pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day2.value)"></th>
              <th v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day3" colspan="2"
                v-html="weeklySummaryLabel(pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day3.value)"></th>
              <th v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day4" colspan="2"
                v-html="weeklySummaryLabel(pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day4.value)"></th>
              <th v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day5" colspan="2"
                v-html="weeklySummaryLabel(pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day5.value)"></th>
              <th v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day6" colspan="2"
                v-html="weeklySummaryLabel(pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day6.value)"></th>
              <th v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day7" colspan="2"
                v-html="weeklySummaryLabel(pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day7.value)"></th>
            </tr>
            <tr v-if="isRsvpSummaryWeekly" class="table-heading">
              <th>Time period</th>
              <th v-if="!!pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day1">PAX</th>
              <th v-if="!!pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day1">RSVP</th>
              <th v-if="!!pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day2">PAX</th>
              <th v-if="!!pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day2">RSVP</th>
              <th v-if="!!pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day3">PAX</th>
              <th v-if="!!pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day3">RSVP</th>
              <th v-if="!!pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day4">PAX</th>
              <th v-if="!!pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day4">RSVP</th>
              <th v-if="!!pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day5">PAX</th>
              <th v-if="!!pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day5">RSVP</th>
              <th v-if="!!pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day6">PAX</th>
              <th v-if="!!pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day6">RSVP</th>
              <th v-if="!!pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day7">PAX</th>
              <th v-if="!!pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day7">RSVP</th>
            </tr>
            <tr v-if="isRsvpTerminal" class="table-heading">
              <th>Time period</th>
              <th v-for="(terminal, i) in pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`]" :key="i">T {{ i.substring(8) }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in pdf.table.data[`page${Object.keys(pdf.table.data).length}`]" :key="index">
              <td v-for="(value, i) in data" :class="[i]" :key="i">{{ value }}</td>
            </tr>
            <tr v-if="isRsvpByDate || isRsvpByRefund" class="subtotal no-border">
              <td :colspan="[isRsvpByRefund ? '8' : '9']" class="total-count">Group Subtotal ({{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].count }})</td>
              <td class="total-pax">{{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].pax }}</td>
              <td class="total-fare">${{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].fare }}</td>
              <td class="total-refund" v-if="isRsvpByRefund">${{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].refund }}</td>
              <td v-if="['completed', 'canceled'].indexOf(selectedDetailed) === -1"></td>
              <td class="extraFee" v-show="(selectedDetailed === 'canceled' || dateType === 'cancelTime') && isRsvpByDate">${{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].cancelFee }}</td>
            </tr>
            <tr v-if="isRsvpByDate" class="total">
              <td colspan="9" class="total-count">Report Total ({{ pdf.table.total.record }})</td>
              <td class="total-pax">{{ pdf.table.total.pax }}</td>
              <td class="total-fare">${{ pdf.table.total.fare }}</td>
              <td class="total-refund" v-if="isRsvpByRefund">${{ pdf.table.total.refund }}</td>
              <td v-if="['completed', 'canceled'].indexOf(selectedDetailed) === -1"></td>
              <td class="extraFee" v-show="selectedDetailed === 'canceled' && isRsvpByDate">${{ pdf.table.total.extraFee }}</td>
            </tr>
            <tr v-if="isRsvpByRefund" class="total">
              <td colspan="8" class="total-count">Report Total ({{ pdf.table.total.record }})</td>
              <td class="total-pax">{{ pdf.table.total.pax }}</td>
              <td class="total-fare">${{ pdf.table.total.fare }}</td>
              <td class="total-refund" v-if="isRsvpByRefund">${{ pdf.table.total.refund }}</td>
              <td v-if="['completed', 'canceled'].indexOf(selectedDetailed) === -1"></td>
              <td class="extraFee" v-show="selectedDetailed === 'canceled' && isRsvpByDate">${{ pdf.table.total.extraFee }}</td>
            </tr>

            <tr v-if="(isRsvpSummary || isDriverReservations || isServiceReservations || isRsvpByGroup || isRsvpByTripStatus || isRsvpByBrands || isRsvpSummaryCorporate)" class="total">
              <td>Total ({{ pdf.table.total.record }})</td>
              <td class="rsvpCount">{{ pdf.table.total.rsvp }}</td>
              <td class="asap">{{ pdf.table.total.asap }}</td>
              <td class="web">{{ pdf.table.total.web }}</td>
              <td class="web">{{ pdf.table.total.admin }}</td>
              <td class="web">{{ pdf.table.total.app }}</td>
              <td class="web">{{ pdf.table.total.go }}</td>
              <td class="totalPax">{{ pdf.table.total.pax }}</td>
              <td class="avgPax">{{ pdf.table.total.avgPax }}</td>
              <td class="dutyHours" v-if="isDriverReservations">{{ pdf.table.total.dutyHours }}</td>
              <td class="totalFare">${{ pdf.table.total.fare }}</td>
              <td class="avgFare">{{ pdf.table.total.avgFare }}</td>
              <td class="avgFarePP">{{ pdf.table.total.avgFarePP }}</td>
              <td class="extraFee"
                v-show="(['canceled', 'promo', 'noshow'].indexOf(selectedSummary) > -1 && isRsvpSummary) || isDriverReservations">${{ pdf.table.total.extraFee }}</td>
              <td class="driverPercent" v-show="isDriverReservations">{{ pdf.table.total.percent }}</td>
            </tr>

            <tr v-if="isRsvpCorporate" class="total">
              <td colspan="7" class="total-count">Total ({{ pdf.table.total.record }})</td>
              <td class="total-fare">${{ pdf.table.total.fare }}</td>
            </tr>

            <tr v-if="isAirportReservations" class="total">
              <td>Total ({{ pdf.table.total.record }})</td>
              <td class="rsvpCount">{{ pdf.table.total.rsvp }}</td>
              <td class="asap">{{ pdf.table.total.asap }}</td>
              <td class="oneway">{{ pdf.table.total.oneway }}</td>
              <td class="roundtrip">{{ pdf.table.total.roundtrip }}</td>
              <td class="roundtripInstances">{{ pdf.table.total.roundtripInstances }}</td>
              <td class="totalRsvpInstances">{{ pdf.table.total.rsvpIsntances }}</td>
              <td class="onewayPercent">{{ pdf.table.total.onewayPercent }}%</td>
              <td class="roundtripPercent">{{ pdf.table.total.roundtripPercent }}%</td>
            </tr>

            <tr v-if="isRsvpSummaryWeekly" class="total">
              <td>Totals</td>
              <td v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day1">{{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day1.pax }}</td>
              <td v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day1">{{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day1.rsvp }}</td>
              <td v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day2">{{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day2.pax }}</td>
              <td v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day2">{{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day2.rsvp }}</td>
              <td v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day3">{{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day3.pax }}</td>
              <td v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day3">{{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day3.rsvp }}</td>
              <td v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day4">{{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day4.pax }}</td>
              <td v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day4">{{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day4.rsvp }}</td>
              <td v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day5">{{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day5.pax }}</td>
              <td v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day5">{{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day5.rsvp }}</td>
              <td v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day6">{{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day6.pax }}</td>
              <td v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day6">{{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day6.rsvp }}</td>
              <td v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day7">{{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day7.pax }}</td>
              <td v-if="pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day7">{{ pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`].day7.rsvp }}</td>
            </tr>

            <tr v-if="isRsvpTerminal" class="total">
              <td>Totals</td>
              <td v-for="(terminal, index) in pdf.table.extra[`page${Object.keys(pdf.table.extra).length}`]" :key="index">{{ terminal.rsvp }}</td>
            </tr>

            <tr v-if="isRsvpByAirportDepArr" class="total">
              <td>Totals</td>
              <td class="departureRsvp">{{ pdf.table.total.departureRsvp }}</td>
              <td class="arrivalRsvp">{{ pdf.table.total.arrivalRsvp }}</td>
              <td class="totalRsvp">{{ pdf.table.total.totalRsvp }}</td>
              <td class="departurePax">{{ pdf.table.total.departurePax }}</td>
              <td class="arrivalPax">{{ pdf.table.total.arrivalPax }}</td>
              <td class="totalPax">{{ pdf.table.total.totalPax }}</td>
            </tr>

            <tr v-if="isRsvpByPayment" class="total">
              <td class="total-label">Totals</td>
              <td class="rsvp">{{ pdf.table.total.rsvp }}</td>
              <td class="pax">{{ pdf.table.total.pax }}</td>
              <td class="charged">${{ pdf.table.total.charged }}</td>
              <td class="gratuity">${{ pdf.table.total.gratuity }}</td>
            </tr>

            <tr v-if="isCreditConverted" class="total">
              <td colspan="7" class="total-count">Total ({{ pdf.table.total.record }})</td>
              <td class="total-pax">{{ pdf.table.total.pax }}</td>
              <td class="total-fare">${{ pdf.table.total.fare }}</td>
              <td class="total-creditReceived">${{ pdf.table.total.creditReceived }}</td>
            </tr>
          </tbody>
        </table>
        <div class="page-count">page {{ Object.keys(pdf.table.data).length }} of {{ totalPage }}</div>
      </div>

    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import datepicker from 'vuejs-datepicker'
import CsvExport from 'csvexport'
import _services from '@/modules/api/services'

export default {
  name: 'rsvp-report',
  components: { datepicker },
  data () {
    return {
      dateType: 'bookingTime',
      from: null,
      to: null,
      isLoading: false,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        rsvpSummary: false,
        rsvpSummaryWeekly: false,
        rsvpByDate: false,
        rsvpByRefund: false,
        rsvpByDriver: false,
        rsvpByDriverFare: false,
        rsvpByServiceType: false,
        rsvpByAirport: false,
        rsvpByAirportDepArr: false,
        rsvpByGroup: false,
        variance: false,
        rsvpByPayment: false,
        rsvpByTripStatus: false,
        rsvpByBrands: false,
        rsvpSummaryCorporate: false,
        rsvpCorporate: false,
        rsvpTerminal: false,
        creditConverted: false,
        bySector: false
      },
      summaryReportStatus: [
        { value: 'all', label: 'All' },
        { value: 'purchased', label: 'Purchased' },
        { value: 'completed', label: 'Completed' },
        { value: 'promo', label: 'Promo' },
        { value: 'canceled', label: 'Canceled' },
        { value: 'noshow', label: 'No Show' }
      ],
      detailedReportStatus: [
        { value: 'all', label: 'All' },
        { value: 'purchased', label: 'Booked' },
        { value: 'completed', label: 'Completed' },
        { value: 'canceled', label: 'Canceled' }
      ],
      reportStatus: {
        rsvpSummary: '',
        rsvpSummaryWeekly: '',
        rsvpByDate: '',
        rsvpByRefund: '',
        rsvpByDriver: '',
        rsvpByDriverFare: '',
        rsvpByServiceType: '',
        rsvpByAirport: '',
        rsvpByAirportDepArr: '',
        rsvpByGroup: '',
        variance: '',
        rsvpByPayment: '',
        rsvpByTripStatus: '',
        rsvpByBrands: '',
        rsvpSummaryCorporate: '',
        rsvpCorporate: '',
        rsvpTerminal: '',
        creditConverted: '',
        bySector: ''
      },
      pdf: {
        code: '',
        class: '',
        title: '',
        date: '',
        table: {
          label: [],
          data: {},
          extra: {},
          total: {}
        },
        maxRecordPerPage: 40,
        list: [],
        current: '',
        loading: false
      },
      selectedSummary: 'all',
      selectedDetailed: 'all',
      selectedAirport: 0,
      orientation: [
        'rsvpSummary', 'rsvpByDate', 'rsvpByRefund', 'rsvpByDriver',
        'rsvpByDriverFare', 'rsvpByServiceType', 'rsvpByGroup', 'variance',
        'rsvpByTripStatus', 'rsvpByBrands', 'rsvpSummaryCorporate', 'rsvpCorporate',
        'creditConverted', 'bySector'
      ],
      pdfChecked: true,
      csvChecked: false,
      formatError: false,
      csv: {
        label: [],
        data: [],
        list: [],
        total: {},
        summaryWeeklyLabel: [],
        terminalLabel: []
      },
      allBrands: [2, 3, 4, 5, 8, 10, 11, 12],
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g),
      bySectorStatus: ''
    }
  },
  computed: {
    show () { return this.$store.state.reports.rsvpReport.show },
    highlightedDates () {
      let self = this
      let result = {
        to: null,
        from: null
      }
      if (self.from !== null) {
        result.from = self.from
      }
      if (self.to !== null) {
        result.to = self.to
      }
      return result
    },
    totalPage () { return Object.keys(this.pdf.table.data).length },
    isRsvpSummary () { return this.pdf.code === 'rsvpSummary' && this.totalPage },
    isRsvpByDate () { return this.pdf.code === 'rsvpByDate' && this.totalPage },
    isRsvpByRefund () { return this.pdf.code === 'rsvpByRefund' && this.totalPage },
    isRsvpByDriver () { return this.pdf.code === 'rsvpByDriver' && this.totalPage },
    isRsvpByDriverFare () { return this.pdf.code === 'rsvpByDriverFare' && this.totalPage },
    isDriverReservations () {
      let accept = ['rsvpByDriver', 'rsvpByDriverFare']
      return accept.indexOf(this.pdf.code) > -1 && this.totalPage
    },
    isServiceReservations () { return this.pdf.code === 'rsvpByServiceType' && this.totalPage },
    isAirportReservations () { return this.pdf.code === 'rsvpByAirport' && this.totalPage },
    isRsvpSummaryWeekly () { return this.pdf.code === 'rsvpSummaryWeekly' && this.totalPage },
    isRsvpByAirportDepArr () { return this.pdf.code === 'rsvpByAirportDepArr' && this.totalPage },
    isRsvpByGroup () { return this.pdf.code === 'rsvpByGroup' && this.totalPage },
    isVariance () { return this.pdf.code === 'variance' && this.totalPage },
    isRsvpByPayment () { return this.pdf.code === 'rsvpByPayment' && this.totalPage },
    isRsvpByTripStatus () { return this.pdf.code === 'rsvpByTripStatus' && this.totalPage },
    isRsvpByBrands () { return this.pdf.code === 'rsvpByBrands' && this.totalPage },
    isRsvpSummaryCorporate () { return this.pdf.code === 'rsvpSummaryCorporate' && this.totalPage },
    isRsvpCorporate () { return this.pdf.code === 'rsvpCorporate' && this.totalPage },
    isRsvpTerminal () { return this.pdf.code === 'rsvpTerminal' && this.totalPage },
    isCreditConverted () { return this.pdf.code === 'creditConverted' && this.totalPage },
    airports () { return this.$store.state.airports.list },
    brands () { return this.$store.state.brands }
  },
  methods: {
    isValid () {
      let self = this
      self.error.show = false
      self.error.empty = []
      if (self.from === null || self.to === null) {
        self.error.show = true
        self.error.message = 'Please specify the Start and End dates.'
        return false
      }

      let from = moment(self.from)
      let to = moment(self.to)

      if (from.isAfter(to)) {
        self.error.show = true
        self.error.message = 'End date must be after Start date.'
        return false
      }

      self.formatError = false
      if (!self.pdfChecked && !self.csvChecked) {
        self.error.show = true
        self.error.message = 'Please select which file format.'
        self.formatError = true
        return false
      }

      if (self.pdfChecked && self.selectedReports.bySector) {
        self.error.show = true
        self.error.message = 'Only CSV format is allowed for Reservation by Sector Report.'
        return false
      }

      if (!self.selectedReports.rsvpSummary && !self.selectedReports.rsvpByDate &&
        !self.selectedReports.rsvpByDriver && !self.selectedReports.rsvpByDriverFare &&
        !self.selectedReports.rsvpByServiceType && !self.selectedReports.rsvpByAirport &&
        !self.selectedReports.rsvpSummaryWeekly && !self.selectedReports.rsvpByAirportDepArr &&
        !self.selectedReports.rsvpByGroup && !self.selectedReports.rsvpByRefund &&
        !self.selectedReports.variance && !self.selectedReports.rsvpByPayment &&
        !self.selectedReports.rsvpByTripStatus && !self.selectedReports.rsvpByBrands &&
        !self.selectedReports.rsvpSummaryCorporate && !self.selectedReports.rsvpCorporate &&
        !self.selectedReports.rsvpTerminal && !self.selectedReports.creditConverted &&
        !self.selectedReports.bySector
      ) {
        self.error.show = true
        self.error.message = 'Please select at least one report type.'
        return false
      }

      if (self.selectedReports.rsvpByAirportDepArr && self.selectedAirport === 0) {
        self.error.show = true
        self.error.message = 'Please select an airport.'
        return false
      }

      return true;
    },
    getNewDoc () {
      let doc = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      })
      doc.setFont('helvetica')
      return doc
    },
    startProcess () {
      if (!this.isValid()) { return }

      this.pdf.list = []
      this.csv.list = []
      for (let report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue'
          this.pdf.list.push(report)
          this.csv.list.push(report)
        }
      }

      this.pdf.loading = true
      this.generateReport()
    },
    generateReport (isCsv = false) {
      if (((!this.pdf.list.length && this.pdfChecked) || !this.pdfChecked) &&
        ((!this.csv.list.length && this.csvChecked) || !this.csvChecked)
      ) {
        this.pdf.loading = false
        return
      }

      if (isCsv) {
        console.log('Processing:', this.csv.list[0])
        this.getDataReports(this.csv.list[0])
      } else {
        console.log('Processing:', this.pdf.list[0])
        this.getDataReports(this.pdf.list[0])
      }
    },
    getDataReports (type) {
      let self = this
      self.reportStatus[type] = 'loading'
      self.isLoading = true
      let orientationMax = self.orientation
      self.pdf.maxRecordPerPage = orientationMax.indexOf(type) > -1 ? 25 : 40
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, r => {
        self.isLoading = false
        if (r.error) {
          self.reportStatus[type] = 'has-error'
          return
        }

        self.setPdfLabel(type)
        self.pdf.table.data = {}
        self.pdf.table.extra = {}
        self.pdf.table.total = {}
        self.csv.data = []
        self.csv.total = {}

        let isEmptyTerminalResult = true
        if (type === 'rsvpTerminal') {
          r.list.forEach((data, index) => {
            if (Object.keys(data.terminals).length) {
              isEmptyTerminalResult = false
            }
          })
        }

        if (type === 'rsvpTerminal' && isEmptyTerminalResult) {
          self.error.show = true
          self.error.empty.push(self.reportLabel(type))
          self.reportStatus[type] = 'has-error'
          self.pdf.list.shift()
          self.csv.list.shift()
          self.generateReport()
          return
        }

        if (type === 'creditConverted' && this.dateType === 'completeTime') {
          r.list = []
        }

        if (type === 'bySector') {
          self.buildSectorData(r)
          return
        }

        if (r.list.length > 0) {
          self.buildPdfData(type, r.list)
        } else {
          self.error.show = true
          self.error.empty.push(self.reportLabel(type))
          self.reportStatus[type] = 'has-error'
          self.pdf.list.shift()
          self.csv.list.shift()
          self.generateReport()
        }
      })
    },
    apiParams (type) {
      let url = ''
      let start = moment(this.from)
      let end = moment(this.to)
      let data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD')
      }

      switch (type) {
        case 'rsvpSummary':
          url = '/reports/rsvp/daily'
          data.status = this.selectedSummary === 'all' ? null : this.selectedSummary
          break
        case 'rsvpByDate':
          url = '/reports/rsvp/list'
          data.status = this.selectedDetailed === 'all' ? null : this.selectedDetailed
          break
        case 'rsvpByRefund':
          url = '/reports/rsvp/refund'
          break
        case 'rsvpByDriver':
          url = '/reports/drivers'
          data.status = 'completed'
          break
        case 'rsvpByDriverFare':
          url = '/reports/drivers'
          data.status = 'completed'
          data.order = 'fareSum'
          data.asc = 0
          break
        case 'rsvpByServiceType':
          url = '/reports/services'
          data.order = 'brandId'
          break
        case 'rsvpByAirport':
          url = '/reports/airports'
          break
        case 'rsvpSummaryWeekly':
          url = '/reports/rsvp/daytime'
          break
        case 'rsvpByAirportDepArr':
          url = '/reports/airports/daily'
          data.geofenceId = this.selectedAirport
          break
        case 'rsvpByGroup':
          url = '/reports/promos'
          break
        case 'variance':
          url = '/reports/rsvp/variance'
          break
        case 'rsvpByPayment':
          url = '/reports/payments'
          break
        case 'rsvpByTripStatus':
          url = '/reports/rsvp/status'
          break
        case 'rsvpByBrands':
          url = '/reports/brands'
          break
        case 'rsvpSummaryCorporate':
          url = '/reports/corporate/list'
          break
        case 'rsvpCorporate':
          url = '/reports/corporate/rsvp'
          break
        case 'rsvpTerminal':
          url = '/reports/terminals'
          break
        case 'creditConverted':
          url = '/reports/rsvp/converted'
          break
        case 'bySector':
          url = '/reports/bysector'
          // data.status = this.bySectorStatus
          break
      }

      data.filter = this.dateType
      return { url: url, data: data }
    },
    setPdfLabel (type) {
      let start = moment(this.from)
      let end = moment(this.to)
      let dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY')

      this.pdf.code = type

      if (type === 'rsvpSummary') {
        this.pdf.class = 'rsvp-summary'
        this.pdf.title = 'Opoli Reservation Summary'
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')'
        this.pdf.table.label = [
          'Date', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin',
          'Consumer <br/>App', 'Go Res', 'Total <br/>PAX', 'Avg <br/>Passengers',
          'Total Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP'
        ]

        if (this.selectedSummary === 'purchased') {
          this.pdf.date = 'By Booking Date (' + dateRange + ')'
        } else if (this.selectedSummary === 'completed') {
          this.pdf.date = 'By Completion Date (' + dateRange + ')'
        } else if (this.selectedSummary === 'canceled') {
          this.pdf.date = 'By Cancellation Date (' + dateRange + ')'
          this.pdf.table.label.push('Cancellation <br/>Fee')
        } else if (this.selectedSummary === 'promo') {
          this.pdf.table.label.push('Promo <br/>Amount')
        } else if (this.selectedSummary === 'noshow') {
          this.pdf.table.label.push('No Show <br/>Fee')
        }
      }

      if (type === 'rsvpByDate') {
        this.pdf.class = 'rsvp-by-date'
        this.pdf.title = 'Opoli Reservation By Date'
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')'
        this.pdf.table.label = [
          'ID', 'Name', 'Source', 'Service', 'Pickup Time', 'Pickup Location',
          'Dropoff Location', 'Flight', 'Flight <br/>Type', 'PAX', 'Fare'
        ]
        if (this.selectedDetailed === 'purchased') {
          this.pdf.date = 'By Booking Date (' + dateRange + ')'
        } else if (this.selectedDetailed === 'completed') {
          this.pdf.date = 'By Completion Date (' + dateRange + ')'
        } else if (this.selectedDetailed === 'canceled') {
          this.pdf.date = 'By Cancellation Date (' + dateRange + ')'
        }
        if (['completed', 'canceled'].indexOf(this.selectedDetailed) === -1) {
          this.pdf.table.label.push('Status')
        }
        if (this.selectedDetailed === 'canceled' || this.dateType === 'cancelTime') {
          this.pdf.table.label.push('Cancellation <br/>Fee')
        }
      }

      if (type === 'rsvpByRefund') {
        this.pdf.class = 'rsvp-by-refund'
        this.pdf.title = 'Opoli Reservation By Refund'
        this.pdf.date = 'By Refund Date (' + dateRange + ')'
        this.pdf.table.label = [
          'ID', 'Name', 'Direction', 'Service', 'Pickup Time', 'Refunded Date',
          'Pickup Location', 'Dropoff Location', 'PAX', 'Fare', 'Refunded <br/>Amount',
        ]
      }

      if (type === 'rsvpByDriver') {
        this.pdf.class = 'driver-rsvp'
        this.pdf.title = 'Opoli Reservations By Driver'
        if (type === 'rsvpByDriverFare') { this.pdf.title = this.pdf.title + ' (Fare)' }
        this.pdf.date = 'By Completion Date (' + dateRange + ')'
        this.pdf.table.label = [
          'Driver', 'Total <br/>Distance','RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin',
          'Consumer <br/>App', 'Go <br/>Res', 'Total <br/>PAX', 'Avg <br/>PAX', 'Duty <br/>Hours',
          'Total <br/>Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP', 'Driver <br/>Payment',
          'Driver %'
        ]
      }
      if (type === 'rsvpByDriverFare') {
        this.pdf.class = 'driver-rsvp'
        this.pdf.title = 'Opoli Reservations By Driver (Fare)'
        this.pdf.date = 'By Completion Date (' + dateRange + ')'
        this.pdf.table.label = [
          'Driver', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin',
          'Consumer <br/>App', 'Go <br/>Res', 'Total <br/>PAX', 'Avg <br/>PAX', 'Duty <br/>Hours',
          'Total <br/>Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP', 'Driver <br/>Payment',
          'Driver %'
        ]
      }

      if (type === 'rsvpByServiceType') {
        this.pdf.class = 'service-rsvp'
        this.pdf.title = 'Opoli Reservations By Service Type'
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')'
        this.pdf.table.label = [
          'Service Type', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin',
          'Consumer <br/>App', 'Go Res', 'Total <br/>PAX', 'Avg <br/>PAX',
          'Total Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP'
        ]
      }

      if (type === 'rsvpByAirport') {
        this.pdf.class = 'airport-rsvp'
        this.pdf.title = 'Opoli Reservations By Airport'
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')'
        this.pdf.table.label = [
          'Airport', 'RSVP <br/>Count', 'ASAP', 'One Way <br/>RSVP', 'Round Trip <br/>RSVP',
          'Round Trip <br/>Instances', 'Total RSVP <br/>Instances ', 'One Way <br/>RSVP (%)',
          'Round Trip <br/>RSVP (%)'
        ]
      }

      if (type === 'rsvpSummaryWeekly') {
        this.pdf.class = 'weekly-summary'
        this.pdf.title = 'Opoli Reservations Weekly Summary'
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')'
      }

      if (type === 'rsvpByAirportDepArr') {
        this.pdf.class = 'airport-rsvp-deparr'
        this.pdf.title = 'Opoli Reservations By Airport (Departure/Arrival)'
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')'
        this.pdf.table.label = [
          'Date', 'Departure RSVP', 'Arrival RSVP',
          'Total RSVP', 'Departure PAX', 'Arrival PAX', 'Total PAX'
        ]
      }

      if (type === 'rsvpByGroup') {
        this.pdf.class = 'promo-rsvp'
        this.pdf.title = 'Opoli Reservations By Group'
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')'
        this.pdf.table.label = [
          'Group <br/>(Direct Bill)', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin',
          'Consumer <br/>App', 'Go Res', 'Total <br/>PAX', 'Avg <br/>PAX',
          'Total Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP'
        ]
      }

      if (type === 'variance') {
        this.pdf.class = 'variance-table'
        this.pdf.title = 'Opoli Reservations - Variance'
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')'
        this.pdf.table.label = [
          'ID', 'Pickup Time', 'Name', 'Pickup', 'Dropoff', 'PAX', 'Payment <br/>Type',
          'Fare', 'CC', 'Other', 'Variance'
        ]
      }

      if (type === 'rsvpByPayment') {
        this.pdf.class = 'payment-rsvp'
        this.pdf.title = 'Opoli Reservations By Payment Type and Source'
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')'
        this.pdf.table.label = [ 'Payment Method', 'RSVP Count', 'Passengers', 'Charged', 'Gratuity' ]
      }

      if (type === 'rsvpByTripStatus') {
        this.pdf.class = 'status-rsvp'
        this.pdf.title = 'Opoli Reservations By Trip Status'
        this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')'
        this.pdf.table.label = [
          'Trip Status', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin',
          'Consumer <br/>App', 'Go Res', 'Total <br/>PAX', 'Avg <br/>PAX',
          'Total Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP'
        ]
      }

      if (type === 'rsvpByBrands') {
        this.pdf.class = 'brands-rsvp'
        this.pdf.title = 'Opoli Reservations By Brands'
        this.pdf.table.label = [
          'Brand', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin',
          'Consumer <br/>App', 'Go Res', 'Total <br/>PAX', 'Avg <br/>PAX',
          'Total Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP'
        ]
      }

      if (type === 'rsvpSummaryCorporate') {
        this.pdf.class = 'summary-corporate-rsvp'
        this.pdf.title = 'Opoli Reservation Summary by Corporate Profile'
        this.pdf.table.label = [
          'Corporate', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin',
          'Consumer <br/>App', 'Go Res', 'Total <br/>PAX', 'Avg <br/>PAX',
          'Total Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP'
        ]
      }

      if (type === 'rsvpCorporate') {
        this.pdf.class = 'corporate-rsvp'
        this.pdf.title = 'Opoli Reservation List by Corporate Profile'
        this.pdf.table.label = [
          'ID', 'Corporate', 'Guest Name (PAX)', 'Service', 'Pickup Time',
          'Pickup Location', 'Dropoff Location', 'Fare'
        ]
      }

      if (type === 'rsvpTerminal') {
        this.pdf.class = 'rsvp-terminal'
        this.pdf.title = 'Opoli Reservation by LAX Terminal'
      }

      if (type === 'creditConverted') {
        this.pdf.class = 'credit-converted'
        this.pdf.title = 'Opoli Reservations by Open Credit'
        this.pdf.table.label = [
          'ID', 'Brand', 'Pickup Time', 'Pickup', 'Dropoff', 'Service',
          'Source', 'PAX', 'Fare', 'Credits'
        ]
      }

      if (type === 'bySector') {
        this.pdf.class = 'bysector'
        this.pdf.title = 'Opoli Reservations by Sector'
        this.csv.label = [
          'Sector Name', 'Brand', 'Service Type',
          'No of Reservation', 'Total Reservation per Sector',
          'Total Amount per Service', 'Total Amount per Sector'
        ]
      }

      switch (this.dateType) {
        case 'bookingTime':
          this.pdf.date = 'By Booking Date (' + dateRange + ')'
          if (type === 'creditConverted') {
            this.pdf.table.label[2] = 'Booking Date'
          }
          break
        case 'cancelTime':
          this.pdf.date = 'By Cancellation Date (' + dateRange + ')'
          if (type === 'creditConverted') {
            this.pdf.table.label[2] = 'Cancelled Date'
          }
          break
        case 'pickupTime':
          this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')'
          break
      }
    },
    buildPdfData (type, pdfData) {
      let self = this
      let groupCount = 0
      let page = 1

      // rsvpByDate
      let groupPax = 0
      let groupFare = 0
      let totalPax = 0
      let totalFare = 0
      let groupCancelFee = 0
      let totalCancelFee = 0

      // rsvpByRefund
      let groupRefund = 0
      let totalRefund = 0

      // rsvpSummary / rsvpByDriver / rsvpByDriverFare / rsvpByServiceType / rsvpByTripStatus
      let totalRsvp = 0
      let totalDistance = 0
      let totalAsap = 0
      let totalWeb = 0
      let totalAdmin = 0
      let totalApp = 0
      let totalGo = 0
      let totalCreditSum = 0
      let totalNoShowFee = 0
      let totalAvgPax = 0
      let totalAvgFare = 0
      let totalAvgFarePP = 0
      let totalDriverPayment = 0

      // rsvpByDriver / rsvpByDriverFare
      let totalDutyHours = 0
      let totalDriverPercentage = 0

      // rsvpByAirport
      let totalOneway = 0
      let totalRoundtrip = 0
      let totalRoundtripInstances = 0
      let totalRsvpInstances = 0
      let totalOnewayPercent = 0
      let totalRoundtripPercent = 0

      // rsvpByPayment
      let totalCharged = 0
      let totalGratuity = 0

      // creditConverted
      let totalCreditReceived = 0

      if (type === 'rsvpTerminal') { // Fill up missing data
        let terminalCount = 0 
        let terminals = []
        pdfData.forEach(function (data, index) {
          if (Object.keys(data.terminals).length > terminalCount) {
            terminalCount = Object.keys(data.terminals).length
          }
          for (let terminal in data.terminals) {
            if (terminals.indexOf(terminal) === -1) {
              terminals.push(terminal)
            }
          }
        })

        terminals.sort()

        pdfData.forEach(function (data, index) {
          terminals.forEach(terminal => {
            if (!data.terminals[terminal]) {
              pdfData[index].terminals[terminal] = 0
            }
          })
        })
      }

      pdfData.forEach(function (data, index) {
        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = []
        }

        if (type === 'rsvpSummaryWeekly') {
          self.buildWeeklyData(data)
        } else if (type === 'rsvpTerminal') {
          self.buildTerminalData(data)
        } else if (type === 'rsvpByAirportDepArr') {
          self.buildAirportDailyData(data.dates)
          self.buildAirportDailyDataCsv(data.dates)
        } else {
          self.pdf.table.data['page' + page].push(self.buildTableData(type, data))
        }

        if (self.csvChecked && type !== 'rsvpByAirportDepArr') {
          self.csv.data.push(self.buildCsvData(type, data))
        }
        groupCount++

        let accept0 = [ 'rsvpByDate', 'rsvpByRefund' ]
        if (accept0.indexOf(type) > -1) {
          totalPax += data.passengers
          totalFare += data.fare
          groupPax += data.passengers
          groupFare += data.fare

          if (type === 'rsvpByRefund') {
            totalRefund += data.refundedAmount
            groupRefund += data.refundedAmount
          }
          if (type === 'rsvpByDate' && (self.selectedDetailed === 'canceled' || self.dateType === 'cancelTime')) {
            totalCancelFee += data.cancelFee
            groupCancelFee += data.cancelFee
          }

          if ((index + 1) % self.pdf.maxRecordPerPage === 0 ||
            pdfData.length === index + 1
          ) {
            self.pdf.table.extra['page' + page] = {}
            self.pdf.table.extra['page' + page].pax = groupPax
            self.pdf.table.extra['page' + page].fare = groupFare.toFixed(2)
            self.pdf.table.extra['page' + page].count = groupCount
            groupPax = 0
            groupFare = 0
            groupCount = 0
            if (type === 'rsvpByRefund') {
              self.pdf.table.extra['page' + page].refund = groupRefund.toFixed(2)
              groupRefund = 0
            }
            if (type === 'rsvpByDate' && (self.selectedDetailed === 'canceled' || self.dateType === 'cancelTime')) {
              self.pdf.table.extra['page' + page].cancelFee = groupCancelFee.toFixed(2)
              groupCancelFee = 0
            }
          }
        }

        let accept1 = [
          'rsvpSummary', 'rsvpByDriver', 'rsvpByDriverFare', 'rsvpByServiceType',
          'rsvpByGroup', 'rsvpByTripStatus', 'rsvpByBrands', 'rsvpSummaryCorporate'
        ]
        if (accept1.indexOf(type) > -1) {
          totalRsvp += data.rsvp
          totalAsap += data.asap
          totalWeb += data.web
          totalAdmin += data.admin
          totalApp += data.app
          totalGo += data.go
          totalPax += data.paxSum
          totalAvgPax += parseFloat(data.paxAvg)
          totalFare += data.fareSum
          totalAvgFare += parseFloat(data.fareAvg)
          totalAvgFarePP += parseFloat(data.farePP)
        }
        if (type === 'rsvpSummary' && self.selectedSummary === 'canceled') {
          totalCancelFee += data.cancelFeeSum
        }
        if (type === 'rsvpSummary' && self.selectedSummary === 'promo') {
          totalCreditSum += data.creditSum
        }
        if (type === 'rsvpSummary' && self.selectedSummary === 'noshow') {
          totalNoShowFee += data.noShowFeeSum
        }
        if (['rsvpByDriver', 'rsvpByDriverFare'].indexOf(type) > -1) {
          totalDutyHours += data.dutyHours
          totalDriverPayment += parseFloat(data.payment)
          totalDriverPercentage += parseFloat(data.payPercent)
        }
        if (type === 'rsvpByDriver') {
          totalDistance += parseFloat(data.distance.toFixed(2))
        }
        if (type === 'rsvpByAirport') {
          totalRsvp += data.rsvp
          totalAsap += data.asap
          totalOneway += data.oneway
          totalRoundtrip += data.roundtrip
          totalRoundtripInstances += parseFloat(data.roundtrip_instances)
          totalRsvpInstances += data.total_instances
          totalOnewayPercent += parseFloat(data.percent_oneway)
          totalRoundtripPercent += parseFloat(data.percent_roundtrip)
        }
        if (type === 'rsvpByPayment') {
          totalRsvp += data.rsvp
          totalPax += data.pax
          totalCharged += data.fare.amount + data.fare.airportFee + data.fare.travelInsurance + data.fare.pickupFee + data.fare.tipAmount
          totalGratuity += data.gratuity
        }
        if (type === 'rsvpCorporate') {
          totalFare += parseFloat(data.amount + data.airportFee + data.travelInsurance + data.tipAmount)
        }
        if (type === 'creditConverted') {
          totalFare += parseFloat(data.fare)
          totalPax += data.passengers
          totalCreditReceived += Math.abs(data.openCredits)
        }

        if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) { page++ }
      })

      if (type === 'rsvpSummary' && totalRsvp <= 0) {
        self.error.show = true
        self.error.empty.push(self.reportLabel(type))
        self.reportStatus[type] = 'has-error'
        self.pdf.list.shift()
        self.csv.list.shift()
        self.generateReport()
        return
      }

      self.pdf.table.total.record = pdfData.length
      let accept0 = [ 'rsvpByDate', 'rsvpByRefund' ]
      if (accept0.indexOf(type) > -1) {
        self.pdf.table.total.pax = self.covertNumber(totalPax)
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2))
        if (type === 'rsvpByRefund') {
          self.pdf.table.total.refund = self.covertNumber(totalRefund.toFixed(2))
        }
      }
      if (type === 'rsvpByDate' && (self.selectedDetailed === 'canceled' || self.dateType === 'cancelTime')) {
        self.pdf.table.total.extraFee = self.covertNumber(totalCancelFee.toFixed(2))
      }
      let accept1 = [
        'rsvpSummary', 'rsvpByDriver', 'rsvpByDriverFare', 'rsvpByServiceType',
        'rsvpByGroup', 'rsvpByTripStatus', 'rsvpByBrands', 'rsvpSummaryCorporate'
      ]
      if (accept1.indexOf(type) > -1) {
        self.pdf.table.total.rsvp = self.covertNumber(totalRsvp)
        self.pdf.table.total.asap = self.covertNumber(totalAsap)
        self.pdf.table.total.web = self.covertNumber(totalWeb)
        self.pdf.table.total.admin = self.covertNumber(totalAdmin)
        self.pdf.table.total.app = self.covertNumber(totalApp)
        self.pdf.table.total.go = self.covertNumber(totalGo)
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2))

        let compAvgPax = totalPax / totalRsvp
        let compAvgFare = totalFare / totalRsvp
        let compAvgFarePP = totalFare / totalPax

        self.pdf.table.total.avgPax = self.covertNumber(compAvgPax.toFixed(2))
        self.pdf.table.total.avgFare = self.covertNumber(compAvgFare.toFixed(2))
        self.pdf.table.total.avgFarePP = self.covertNumber(compAvgFarePP.toFixed(2))
        if (type !== 'trxSummary') {
          self.pdf.table.total.pax = self.covertNumber(totalPax)
        }
      }
      if (type === 'rsvpSummary' && self.selectedSummary === 'canceled') {
        self.pdf.table.total.extraFee = self.covertNumber(totalCancelFee.toFixed(2))
      }
      if (type === 'rsvpSummary' && self.selectedSummary === 'promo') {
        self.pdf.table.total.extraFee = self.covertNumber(totalCreditSum.toFixed(2))
      }
      if (type === 'rsvpSummary' && self.selectedSummary === 'noshow') {
        self.pdf.table.total.extraFee = self.covertNumber(totalNoShowFee.toFixed(2))
      }
      if (['rsvpByDriver', 'rsvpByDriverFare'].indexOf(type) > -1) {
        let averagePercentage = totalDriverPercentage / pdfData.length
        let minutes = Math.round(totalDutyHours * 60)
        let hour = Math.floor(minutes / 60)
        let hourDisplay = hour < 10 ? '0' + hour : hour
        self.pdf.table.total.dutyHours = hourDisplay + ':' + ('0' + (minutes - (hour * 60))).slice(-2)
        self.pdf.table.total.extraFee = self.covertNumber(totalDriverPayment.toFixed(2))
        self.pdf.table.total.percent = self.covertNumber(averagePercentage.toFixed(2))
      }
      if (type === 'rsvpByDriver') {
        self.pdf.table.total.distance = self.covertNumber(totalDistance.toFixed(2))
      }
      if (type === 'rsvpByAirport') {
        self.pdf.table.total.rsvp = self.covertNumber(totalRsvp)
        self.pdf.table.total.asap = self.covertNumber(totalAsap)
        self.pdf.table.total.oneway = self.covertNumber(totalOneway)
        self.pdf.table.total.roundtrip = self.covertNumber(totalRoundtrip)
        self.pdf.table.total.roundtripInstances = self.covertNumber(totalRoundtripInstances.toFixed(2))
        self.pdf.table.total.rsvpIsntances = self.covertNumber(totalRsvpInstances.toFixed(2))
        self.pdf.table.total.onewayPercent = (totalOnewayPercent / pdfData.length).toFixed(2)
        self.pdf.table.total.roundtripPercent = (totalRoundtripPercent / pdfData.length).toFixed(2)
      }
      if (type === 'rsvpSummaryWeekly') {
        page = Math.ceil(pdfData[0].dates.length / 7)
      }
      if (type === 'rsvpByAirportDepArr') {
        page = Math.ceil(Object.keys(pdfData[0].dates).length / self.pdf.maxRecordPerPage)
      }
      if (type === 'rsvpByPayment') {
        self.pdf.table.total.rsvp = self.covertNumber(totalRsvp)
        self.pdf.table.total.pax = self.covertNumber(totalPax)
        self.pdf.table.total.charged = self.covertNumber(parseFloat(totalCharged).toFixed(2))
        self.pdf.table.total.gratuity = self.covertNumber(parseFloat(totalGratuity).toFixed(2))
      }
      if (type === 'rsvpCorporate') {
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2))
      }
      if (type === 'rsvpTerminal') {
        page = Math.ceil(Object.keys(pdfData[0].terminals).length / 9)
      }
      if (type === 'creditConverted') {
        self.pdf.table.total.pax = self.covertNumber(totalPax)
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2))
        self.pdf.table.total.creditReceived = self.covertNumber(totalCreditReceived.toFixed(2))
      }

      if (type === 'rsvpByBrands') {
        let allBrands = [...self.allBrands]
        self.pdf.table.data['page' + page].forEach(b => {
          let i = self.brands.list.findIndex(x => x.name === b.brand)
          if (i > -1) {
            if (allBrands.indexOf(self.brands.list[i].id) > -1) {
              allBrands.splice(allBrands.indexOf(self.brands.list[i].id), 1)
            }
          }
        })
        self.pdf.table.total.record += allBrands.length
        allBrands.forEach(x => {
          let brand = self.brands.list.find(n => n.id === x)
          self.pdf.table.data['page' + page].push({
            brand: brand.name,
            rsvpCount: self.covertNumber(0),
            asap: self.covertNumber(0),
            web: self.covertNumber(0),
            admin: self.covertNumber(0),
            app: self.covertNumber(0),
            go: self.covertNumber(0),
            totalPax: self.covertNumber(0),
            avgPax: self.covertNumber(parseFloat(0).toFixed(2)),
            totalFare: self.covertNumber(parseFloat(0).toFixed(2)),
            avgFare: self.covertNumber(parseFloat(0).toFixed(2)),
            avgFarePP: self.covertNumber(parseFloat(0).toFixed(2))
          })
        })
      }

      if (self.pdfChecked) {
        self.processDownloads('pdf', {type: type, page: page})
      } else {
        self.processDownloads('csv', {type: type})
      }
      // self.processPdf(type, page)
    },
    buildTableData (type, data) {
      let self = this
      if (type === 'rsvpSummary') {
        let rsvpSummaryData ={
          date: moment(data.date, 'YYYY-MM-DD').format('MM/DD/YYYY'),
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          web: self.covertNumber(data.web),
          admin: self.covertNumber(data.admin),
          app: self.covertNumber(data.app),
          go: self.covertNumber(data.go),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2))
        }
        if (self.selectedSummary === 'canceled') {
          rsvpSummaryData.extraFee = self.covertNumber(parseFloat(data.cancelFeeSum).toFixed(2))
        }
        if (self.selectedSummary === 'promo') {
          rsvpSummaryData.extraFee = self.covertNumber(parseFloat(data.creditSum).toFixed(2))
        }
        if (self.selectedSummary === 'noshow') {
          rsvpSummaryData.extraFee = self.covertNumber(parseFloat(data.noShowFeeSum).toFixed(2))
        }
        return rsvpSummaryData
      }

      if (type === 'rsvpByDate') {
        let source = 'Web'
        if (['android', 'ios'].indexOf(data.deviceType) > -1) { source = 'CA' }
        if (data.deviceType === 'admin') { source = 'Admin' }
        if (data.deviceType === 'CSR') { source = 'CSR' }
        let flight = 'N/A'
        if (data.airlineCode) { flight = data.airlineCode + ' ' + data.flightNumber }
        if (data.flightName) { flight = data.flightName + ' ' + data.flightNumber }
        let domIntl = '--'
        if (data.isDomestic === true) { domIntl = 'DOM' }
        else if (data.isDomestic === false) { domIntl = 'INTL' }
        if (data.direction === 'PP' || flight === 'N/A') { domIntl = 'N/A' }
        let service = data.service
        if (data.brandId) {
          let brandCode = CONFIG.brands.filter(x => x.id === data.brandId)[0]
          service = '[' + brandCode.code.toUpperCase() + '] ' + data.service
        }
        let rsvpByDateData =  {
          id: data.ID,
          name: data.name,
          source: source,
          service: service,
          pickupTime: moment(data.localPickupTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm'),
          pickupLocation: data.pickupLocation,
          dropoffLocation: data.dropoffLocation,
          flight: flight,
          flightType: domIntl,
          pax: self.covertNumber(data.passengers),
          fare: self.covertNumber(data.fare.toFixed(2))
          // status: data.status
        }
        if (['completed', 'canceled'].indexOf(self.selectedDetailed) === -1) {
          rsvpByDateData.status = data.status
        }
        if (self.selectedDetailed === 'canceled' || self.dateType === 'cancelTime') {
          data.cancelFee = data.cancelFee || 0
          rsvpByDateData.extraFee = self.covertNumber(data.cancelFee.toFixed(2))
        }
        return rsvpByDateData
      }

      if (type === 'rsvpByRefund') {
        let service = data.service
        if (data.brandId) {
          let brandCode = CONFIG.brands.filter(x => x.id === data.brandId)[0]
          service = '[' + brandCode.code.toUpperCase() + '] ' + data.service
        }
        return {
          id: data.ID,
          name: data.name,
          direction: data.direction,
          service: service,
          pickupTime: moment(data.localPickupTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm'),
          refundedDate: moment(data.refundedDate, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY HH:mm'),
          pickupLocation: data.pickupLocation,
          dropoffLocation: data.dropoffLocation,
          pax: self.covertNumber(data.passengers),
          fare: self.covertNumber(data.fare.toFixed(2)),
          refundAmount: self.covertNumber(data.refundedAmount.toFixed(2))
        }
      }

      if (type === 'rsvpByDriver') {
        let minutes = Math.round(data.dutyHours * 60)
        let hour = Math.floor(minutes / 60)
        let hourDisplay = hour < 10 ? '0' + hour : hour
        return {
          driver: data.driverId + ' ' + data.name,
          distance: self.covertNumber(parseFloat(data.distance || 0).toFixed(2)),
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          web: self.covertNumber(data.web),
          admin: self.covertNumber(data.admin),
          app: self.covertNumber(data.app),
          go: self.covertNumber(data.go),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          dutyHours: hourDisplay + ':' + ('0' + (minutes - (hour * 60))).slice(-2),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2)),
          driverPayment: self.covertNumber(parseFloat(data.payment).toFixed(2)),
          driverPercent: self.covertNumber(parseFloat(data.payPercent).toFixed(2))
        }
      }

      if (type === 'rsvpByDriverFare') {
        let minutes = Math.round(data.dutyHours * 60)
        let hour = Math.floor(minutes / 60)
        let hourDisplay = hour < 10 ? '0' + hour : hour
        return {
          driver: data.driverId + ' ' + data.name,
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          web: self.covertNumber(data.web),
          admin: self.covertNumber(data.admin),
          app: self.covertNumber(data.app),
          go: self.covertNumber(data.go),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          dutyHours: hourDisplay + ':' + ('0' + (minutes - (hour * 60))).slice(-2),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2)),
          driverPayment: self.covertNumber(parseFloat(data.payment).toFixed(2)),
          driverPercent: self.covertNumber(parseFloat(data.payPercent).toFixed(2))
        }
      }

      if (type === 'rsvpByServiceType') {
        let service = data.name
        if (data.serviceId > 5) {
          let brandCode = CONFIG.brands.filter(x => x.id === data.brandId)[0]
          service = '[' + brandCode.code.toUpperCase() + '] ' + data.name
        }
        return {
          service: service,
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          web: self.covertNumber(data.web),
          admin: self.covertNumber(data.admin),
          app: self.covertNumber(data.app),
          go: self.covertNumber(data.go),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2))
        }
      }

      if (type === 'rsvpByAirport') {
        return {
          airport: data.label,
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          oneway: self.covertNumber(data.oneway),
          roundtrip: self.covertNumber(data.roundtrip),
          roundtripInstances: self.covertNumber(parseFloat(data.roundtrip_instances).toFixed(2)),
          totalRsvpInstances: self.covertNumber(data.total_instances.toFixed(2)),
          onewayPercent: self.covertNumber(parseFloat(data.percent_oneway).toFixed(2)),
          roundtripPercent: self.covertNumber(parseFloat(data.percent_roundtrip).toFixed(2))
        }
      }

      if (type === 'rsvpByGroup') {
        let promo = data.promoCode ? '(' + data.promoCode + ') ' : ''
        promo = promo + data.name
        return {
          promo: promo,
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          web: self.covertNumber(data.web),
          admin: self.covertNumber(data.admin),
          app: self.covertNumber(data.app),
          go: self.covertNumber(data.go),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(data.paxAvg),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2))
        }
      }

      if (type === 'variance') {
        let variance = self.covertNumber(Math.abs(parseFloat(data.variance)).toFixed(2))
        if (parseFloat(data.variance) < 0) {
          variance = '(' + variance + ')'
        }
        let fare = data.fare.airportFee + data.fare.amount + data.fare.pickupFee + data.fare.tipAmount
        let paymentType = ''
        if (data.payments.card) { paymentType = 'CC' }
        else if (data.payments.other) { paymentType = 'Other' }

        return {
          id: data.rsvpId,
          pickupTime: moment(data.localPickupTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm'),
          name: data.name,
          pickup: data.pickupLocation,
          dropoff: data.dropoffLocation,
          pax: data.passengers,
          paymentType: paymentType,
          fare: self.covertNumber(parseFloat(fare).toFixed(2)),
          cc: self.covertNumber(parseFloat(data.payments.card).toFixed(2)),
          other: self.covertNumber(parseFloat(data.payments.other).toFixed(2)),
          variance: variance
        }
      }

      if (type === 'rsvpByPayment') {
        let amount = data.fare.airportFee + data.fare.amount + data.fare.travelInsurance + data.fare.pickupFee + data.fare.tipAmount
        return {
          name: data.method,
          rsvp: self.covertNumber(data.rsvp),
          pax: self.covertNumber(data.pax),
          charged: self.covertNumber(parseFloat(amount).toFixed(2)),
          gratuity: self.covertNumber(parseFloat(data.gratuity).toFixed(2))
        }
      }

      if (type === 'rsvpByTripStatus') {
        return {
          status: data.status,
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          web: self.covertNumber(data.web),
          admin: self.covertNumber(data.admin),
          app: self.covertNumber(data.app),
          go: self.covertNumber(data.go),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2))
        }
      }

      if (type === 'trxSummary') {
        let netTotal = parseFloat(data.chargedAmount) - parseFloat(data.refundAmount)
        return {
          date: moment(data.date, 'YYYY-MM-DD').format('MM/DD/YYYY'),
          trxCount: self.covertNumber(data.trx),
          chargedTrxCount: self.covertNumber(data.charged),
          chargedAmount: self.covertNumber(parseFloat(data.chargedAmount).toFixed(2)),
          refundTrxCount: self.covertNumber(data.refund),
          refundAmount: self.covertNumber(parseFloat(data.refundAmount).toFixed(2)),
          netTotal: self.covertNumber(parseFloat(netTotal).toFixed(2))
          // rsvpCount: self.covertNumber(data.rsvp),
          // purchaseCount: self.covertNumber(data.purchase),
          // additionalCount: self.covertNumber(data.extra),
          // totalCharges: self.covertNumber(parseFloat(data.amount).toFixed(2))
        }
      }

      if (type === 'trxDetailed') {
        // let trxType = data.type === 'cancelFee' ? 'cancel fee' : data.type
        let charged = data.trxType !== 'Refund' ? self.covertNumber(parseFloat(data.chargedAmount).toFixed(2)) : '-'
        let refund = data.trxType === 'Refund' ? self.covertNumber(parseFloat(data.chargedAmount).toFixed(2)) : '-'
        return {
          date: moment(data.created, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY  HH:mm'),
          customer: data.customer,
          cardOwner: data.cardOwner,
          rsvpId: data.rsvpId,
          invoiceId: data.invoiceID,
          transactionType: data.trxType,
          // transactionType: trxType,
          chargedAmount: charged,
          refundAmount: refund
        }
      }

      if (type === 'rsvpByBrands') {
        return {
          brand: data.name,
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          web: self.covertNumber(data.web),
          admin: self.covertNumber(data.admin),
          app: self.covertNumber(data.app),
          go: self.covertNumber(data.go),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2))
        }
      }

      if (type === 'rsvpSummaryCorporate') {
        return {
          brand: data.name,
          rsvpCount: self.covertNumber(data.rsvp),
          asap: self.covertNumber(data.asap),
          web: self.covertNumber(data.web),
          admin: self.covertNumber(data.admin),
          app: self.covertNumber(data.app),
          go: self.covertNumber(data.go),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2))
        }
      }

      if (type === 'rsvpCorporate') {
        return {
          rsvpId: data.rsvpId,
          corporate: data.corporateName,
          guest: data.guestName + ' (' + data.passengers + ')',
          service: data.serviceTypeName,
          pickupTime: moment(data.pickupTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm'),
          pickupLocation: data.pickupLocation,
          dropoffLocation: data.dropoffLocation,
          fare: self.covertNumber(parseFloat(data.amount + data.airportFee + data.travelInsurance + data.tipAmount).toFixed(2))
        }
      }

      if (type === 'creditConverted') {
        let brandCode = CONFIG.brands.filter(x => x.id === data.brandId)[0]
        let source = 'Web'
        if (['android', 'ios'].indexOf(data.deviceType) > -1) { source = 'CA' }
        if (data.deviceType === 'admin') { source = 'Admin' }
        if (data.deviceType === 'CSR') { source = 'CSR' }
        let pickupTime = moment(data.localPickupTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm')
        if (self.dateType === 'bookingTime') {
          pickupTime = moment(data.bookingTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY HH:mm')
        } else if (self.dateType === 'cancelTime') {
          pickupTime = moment(data.cancelTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY HH:mm')
        }
        return {
          rsvpId: data.ID,
          brand: brandCode.code.toUpperCase(),
          pickupTime: pickupTime,
          pickup: data.pickupLocation,
          dropoff: data.dropoffLocation,
          service: data.service,
          source: source,
          pax: self.covertNumber(data.passengers),
          fare: self.covertNumber(parseFloat(data.fare).toFixed(2)),
          creditReceived: self.covertNumber(parseFloat(Math.abs(data.openCredits)).toFixed(2))
        }
      }

      if (type === 'bySector') {
        return {
          rsvpId: data.ID
        }
      }
    },
    buildWeeklyData (data) {
      let self = this
      let time = moment(data.hour, 'HH:mm').add(59, 'minutes')
      let rowData = { time: data.hour + '-' + time.format('HH:mm') }

      let dayCounter = 1
      let page = 1

      self.csv.summaryWeeklyLabel = ['Time period']
      data.dates.forEach(function (data2, index) {
        let day = moment(data2.date, 'YYYY-MM-DD')
        rowData[day.format('dddd') + 'Pax'] = data2.pax
        rowData[day.format('dddd') + 'Rsvp'] = data2.rsvp

        self.csv.summaryWeeklyLabel.push(day.format('MM/DD/YYYY') + ' PAX')
        self.csv.summaryWeeklyLabel.push(day.format('MM/DD/YYYY') + ' RSVP')

        if (!self.pdf.table.extra['page' + page]) {
          self.pdf.table.extra['page' + page] = {}
        }
        if (!self.pdf.table.extra['page' + page]['day' + dayCounter]) {
          self.pdf.table.extra['page' + page]['day' + dayCounter] = {}
          self.pdf.table.extra['page' + page]['day' + dayCounter].pax = 0
          self.pdf.table.extra['page' + page]['day' + dayCounter].rsvp = 0
          self.pdf.table.extra['page' + page]['day' + dayCounter].value = ''
        }
        self.pdf.table.extra['page' + page]['day' + dayCounter].pax += data2.pax
        self.pdf.table.extra['page' + page]['day' + dayCounter].rsvp += data2.rsvp
        self.pdf.table.extra['page' + page]['day' + dayCounter].value = day.format('MM/DD/YYYY')

        if (dayCounter === 7 || (index + 1) === data.dates.length) {
          if (!self.pdf.table.data['page' + page]) {
            self.pdf.table.data['page' + page] = []
          }

          self.pdf.table.data['page' + page].push(rowData)
          rowData = { time: data.hour + '-' + time.format('HH:mm') }

          dayCounter = 1
          page++
        } else {
          dayCounter++
        }
      })
    },
    buildTerminalData (data) {
      let self = this
      let time = moment(data.hour, 'HH:mm').add(59, 'minutes')
      let rowData = { time: data.hour + '-' + time.format('HH:mm') }

      let dayCounter = 1
      let page = 1

      self.csv.terminalLabel = ['Time period']
      for (let index in data.terminals) {
        rowData['terminal' + index] = data.terminals[index]

        self.csv.terminalLabel.push('Terminal ' + index)

        if (!self.pdf.table.extra['page' + page]) {
          self.pdf.table.extra['page' + page] = {}
        }
        if (!self.pdf.table.extra['page' + page]['terminal' + index]) {
          self.pdf.table.extra['page' + page]['terminal' + index] = {}
          self.pdf.table.extra['page' + page]['terminal' + index] = { rsvp: 0 }
        }
        self.pdf.table.extra['page' + page]['terminal' + index].rsvp += data.terminals[index]

        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = []
        }
      }
      self.pdf.table.data['page' + page].push(rowData)
    },
    buildAirportDailyData (data) {
      let self = this
      let page = 1
      let rowCount = 1

      let departureRsvp = 0
      let arrivalRsvp = 0
      let totalRsvp = 0
      let departurePax = 0
      let arrivalPax = 0
      let totalPax = 0

      for (let index in data) {
        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = []
        }
        self.pdf.table.data['page' + page].push({
          date: moment(index, 'YYYY-MM-DD').format('MM/DD/YYYY'),
          departureRsvp: self.covertNumber(data[index].depRsvp),
          arrivalRsvp: self.covertNumber(data[index].arrRsvp),
          totalRsvp: self.covertNumber(data[index].sumRsvp),
          departurePax: self.covertNumber(data[index].depPax),
          arrivalPax: self.covertNumber(data[index].arrPax),
          totalPax: self.covertNumber(data[index].sumPax)
        })

        departureRsvp += data[index].depRsvp
        arrivalRsvp += data[index].arrRsvp
        totalRsvp += data[index].sumRsvp
        departurePax += data[index].depPax
        arrivalPax += data[index].arrPax
        totalPax += data[index].sumPax

        if (rowCount % self.pdf.maxRecordPerPage === 0 && Object.keys(data).length !== rowCount) {
          rowCount = 1
          page++
        } else {
          rowCount++
        }
      }

      self.pdf.table.total.departureRsvp = self.covertNumber(departureRsvp)
      self.pdf.table.total.arrivalRsvp = self.covertNumber(arrivalRsvp)
      self.pdf.table.total.totalRsvp = self.covertNumber(totalRsvp)
      self.pdf.table.total.departurePax = self.covertNumber(departurePax)
      self.pdf.table.total.arrivalPax = self.covertNumber(arrivalPax)
      self.pdf.table.total.totalPax = self.covertNumber(totalPax)
    },
    fileName (type, format) {
      let timestamp = moment(this.from).format('YYYYMMDD') + '_' + moment(this.to).format('YYYYMMDD')
      switch (type) {
        case 'rsvpSummary': return 'rsvpsummary_' + timestamp + '.' + format
        case 'rsvpByDate': return 'rsvpbydate_' + timestamp + '.' + format
        case 'rsvpByRefund': return 'rsvpbyrefund_' + timestamp + '.' + format
        case 'rsvpByDriver': return 'rsvpbydriver_' + timestamp + '.' + format
        case 'rsvpByDriverFare': return 'rsvpbydriverfare_' + timestamp + '.' + format
        case 'rsvpByServiceType': return 'rsvpbyservicetype_' + timestamp + '.' + format
        case 'rsvpByAirport': return 'rsvpbyairport_' + timestamp + '.' + format
        case 'rsvpSummaryWeekly': return 'rsvpsummaryweekly_' + timestamp + '.' + format
        case 'rsvpByAirportDepArr': return 'rsvpbyairportdeparturearrival_' + timestamp + '.' + format
        case 'rsvpByGroup': return 'rsvpbygroup_' + timestamp + '.' + format
        case 'variance': return 'variance_' + timestamp + '.' + format
        case 'rsvpByPayment': return 'rsvpbypayment_' + timestamp + '.' + format
        case 'rsvpByTripStatus': return 'rsvpbytripstatus_' + timestamp + '.' + format
        case 'rsvpByBrands': return 'rsvpbybrands_' + timestamp + '.' + format
        case 'rsvpSummaryCorporate': return 'rsvpsummary-corporate_' + timestamp + '.' + format
        case 'rsvpCorporate': return 'rsvpcorporate_' + timestamp + '.' + format
        case 'rsvpTerminal': return 'rsvpterminal_' + timestamp + '.' + format
        case 'creditConverted': return 'creditConverted' + timestamp + '.' + format
        case 'bySector': return 'bySector' + timestamp + '.' + format
      }
    },
    currentPage (page) { return page.substring(4) },
    processPdf (type, page) {
      let self = this
      let start = moment(self.from)
      let end = moment(self.to)
      let pageAsyncs  = []
      let landscapeReports = self.orientation
      let orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p'
      let pdf = new jsPDF({ orientation: orientation, unit: 'mm', format: 'a4' })

      window.scrollTo(500, 0)
      document.body.style.overflow = 'hidden'

      setTimeout(() => {
        if (self.isIOS) page = page + 1
        // for (let i = 0; i < page; i++) {
        //   pageAsyncs.push(html2canvas(document.getElementsByClassName('page' + (i + 1))[0], {
        //     scale: "1"
        //   }).then(canvas => {
        //     let imgData = canvas.toDataURL('image/jpeg', 0.9)
        //     pdf.addImage(imgData, 'JPEG', 0, 0)
        //     if (i + 1 !== page) { pdf.addPage() }
        //   }).catch(e => {
        //     self.reportStatus[type] = 'has-error'
        //     self.pdf.list.shift()
        //     document.body.style.overflow = 'auto'
        //     self.processDownloads('csv', {type: type})
        //     console.warn(e)
        //   }))
        // }

        var i = 0
        var buildPdfPages = (i) => {
          if (i + 1 > page) {
            downloadPdfPages()
            return
          }
          pageAsyncs.push(html2canvas(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(canvas => {
            let imgData = canvas.toDataURL('image/jpeg', 1.0)
            pdf.addImage(imgData, 'JPEG', 0, 0)
            if (i + 1 <= page) {
              pdf.addPage()
              buildPdfPages(i + 1)
            }
          }).catch(e => {
            self.reportStatus[type] = 'has-error'
            self.pdf.list.shift()
            document.body.style.overflow = 'auto'
            self.processDownloads('csv', {type: type})
            console.warn(e)
          }))
        }
        buildPdfPages(0)

        var downloadPdfPages = () => {
          pdf.save(self.fileName(type, 'pdf'))
          self.reportStatus[type] = 'success'
          self.pdf.list.shift()
          document.body.style.overflow = 'auto'
          self.processDownloads('csv', {type: type})
        }

        // Promise.all(pageAsyncs).then(() => {
        //   let timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD')
        //   pdf.save(self.fileName(type, 'pdf'))
        //   self.reportStatus[type] = 'success'
        //   self.pdf.list.shift()
        //   document.body.style.overflow = 'auto'
        //   self.processDownloads('csv', {type: type})
        // })
      }, 500)
    },
    covertNumber (value) { return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") },
    weeklySummaryLabel (date) {
      if (!date) { return '' }
      return moment(date, 'MM/DD/YYYY').format('dddd') + '<br/>' + date
    },
    resetSelectedStatus () {
      this.selectedReports = {
        rsvpSummary: false, rsvpSummaryWeekly: false, rsvpByDate: false,
        rsvpByRefund: false, rsvpByDriver: false, rsvpByDriverFare: false,
        rsvpByServiceType: false, rsvpByAirport: false, rsvpByAirportDepArr: false,
        rsvpByGroup: false, variance: false, rsvpByPayment: false,
        rsvpByTripStatus: false, rsvpByBrands: false, rsvpSummaryCorporate: false,
        rsvpCorporate: false, rsvpTerminal: false, creditConverted: false,
        bySector: false
      }
    },
    resetReportStatus () {
      this.error.show = false
      this.error.empty = []
      this.reportStatus = {
        rsvpSummary: '', rsvpSummaryWeekly: '', rsvpByDate: '', rsvpByRefund: '',
        rsvpByDriver: '', rsvpByDriverFare: '', rsvpByServiceType: '', rsvpByAirport: '',
        rsvpByAirportDepArr: '', rsvpByGroup: '', variance: '', rsvpByPayment: '',
        rsvpByBrands: '', rsvpSummaryCorporate: '', rsvpTerminal: '', creditConverted: '',
        bySector: ''
      }
    },
    reportLabel (type) {
      switch (type) {
        case 'rsvpSummary': return 'Reservations Summary'
        case 'rsvpSummaryWeekly': return 'Reservations Summary (weekly)'
        case 'rsvpByDate': return 'Reservations by Date'
        case 'rsvpByRefund': return 'Reservations by Refund'
        case 'rsvpByDriver': return 'Reservations by Driver'
        case 'rsvpByDriverFare': return 'Reservations by Driver (fare)'
        case 'rsvpByServiceType': return 'Reservations by Service Type'
        case 'rsvpByAirport': return 'Reservations by Airport'
        case 'rsvpByAirportDepArr': return 'Reservations by Airport (departure/arrival)'
        case 'rsvpByGroup': return 'Reservations by Group'
        case 'variance': return 'Variance Report'
        case 'rsvpByPayment': return 'Reservations by Payment Type and Source'
        case 'rsvpByTripStatus': return 'Reservations by Trip Status'
        case 'rsvpByBrands': return 'Reservations by Brands'
        case 'rsvpSummaryCorporate': return 'Reservations Summary by Corporate Profile'
        case 'rsvpCorporate': return 'Reservations List by Corporate Profile'
        case 'rsvpTerminal': return 'Reservations by LAX Terminal'
        case 'creditConverted': return 'Reservations by Open Credit'
        case 'bySector': return 'Reservations by Sector'
      }
    },
    disableOption (select, type) {
      let opt = ['rsvpSummary', 'rsvpByDate']
      if (opt.indexOf(select) > -1 && type === 'canceled' && this.dateType === 'completeTime') { return true }
      if (opt.indexOf(select) > -1 && type === 'completed' && this.dateType === 'cancelTime') { return true }
    },
    buildCsvData (type, data) {
      let column = []
      this.pdf.table.label.forEach(function(i) {
        column.push(i.replace('<br/>', ''))
      })
      if (type === 'rsvpSummaryWeekly') {
        column = this.csv.summaryWeeklyLabel
      }
      if (type === 'rsvpTerminal') {
        column = this.csv.terminalLabel
      }
      this.csv.label = column

      let csvData = {}
      let pdfData = ''
      if (type === 'rsvpSummaryWeekly') {
        pdfData = this.buildWeeklyDataCsv(data)
      } else if (type === 'rsvpTerminal') {
        pdfData = this.buildTerminalDataCsv(data)
      } else if (type === 'rsvpByAirportDepArr') {
        this.buildAirportDailyDataCsv(data.dates)
        return
      } else {
        pdfData = this.buildTableData(type, data)
      }

      let i = 0
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key]
        i++
      }
      return csvData
    },
    buildWeeklyDataCsv (data) {
      let self = this
      var columnData = {}
      for (var i in data) {
        if (i === 'hour') {
          let hour = moment(data[i], 'HH:mm').add(59, 'minutes')
          columnData['hour'] = data[i] + '-' + hour.format('HH:mm')
        } else {
          data[i].forEach(function(key, index) {
            columnData[key.date + 'pax'] = key.pax
            columnData[key.date + 'rsvp'] = key.rsvp

            if (!self.csv.total[key.date + 'pax']) { self.csv.total[key.date + 'pax'] = 0 }
            if (!self.csv.total[key.date + 'rsvp']) { self.csv.total[key.date + 'rsvp'] = 0 }
            self.csv.total[key.date + 'pax'] += key.pax
            self.csv.total[key.date + 'rsvp'] += key.rsvp
          })
        }
      }
      return columnData
    },
    buildTerminalDataCsv (data) {
      let self = this
      var columnData = {}
      for (var i in data) {
        if (i === 'hour') {
          let hour = moment(data[i], 'HH:mm').add(59, 'minutes')
          columnData['hour'] = data[i] + '-' + hour.format('HH:mm')
        } else {
          for (let terminal in data.terminals) {
            columnData['Terminal' + terminal] = data.terminals[terminal]

            if (!self.csv.total['Terminal ' + terminal]) { self.csv.total['Terminal' + terminal] = 0 }
            self.csv.total['Terminal' + terminal] += data.terminals[terminal]
          }
        }
      }
      return columnData
    },
    buildAirportDailyDataCsv (data) {
      let column = []
      this.pdf.table.label.forEach(function(i) {
        column.push(i.replace('<br/>', ''))
      })
      this.csv.label = column

      this.csv.data = []
      for (let index in data) {
        let columnData = {}
        columnData[column[0]] = moment(index, 'YYYY-MM-DD').format('MM/DD/YYYY')
        columnData[column[1]] = this.covertNumber(data[index].depRsvp)
        columnData[column[2]] = this.covertNumber(data[index].arrRsvp)
        columnData[column[3]] = this.covertNumber(data[index].sumRsvp)
        columnData[column[4]] = this.covertNumber(data[index].depPax)
        columnData[column[5]] = this.covertNumber(data[index].arrPax)
        columnData[column[6]] = this.covertNumber(data[index].sumPax)
        this.csv.data.push(columnData)
      }
    },
    processDownloads (action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page)
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type)
      } else {
        this.generateReport()
      }
    },
    processCsv (type) {
      const exporter = CsvExport.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      })

      // add total
      this.csv.data.push(this.buildCsvTotal(type))

      this.reportStatus[type] = 'success'
      this.csv.list.shift()
      exporter.downloadCsv(this.csv.data)

      this.generateReport(true)
    },
    buildCsvTotal (type) {
      let csvData = {}
      let totalData = this.pdf.table.total

      if (['rsvpSummary', 'rsvpByDriver', 'rsvpByDriverFare', 'rsvpByServiceType', 'rsvpByGroup', 'rsvpByTripStatus', 'rsvpByBrands', 'rsvpSummaryCorporate'].indexOf(type) > -1) {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')'
        csvData[this.csv.label[1]] = totalData.rsvp
        csvData[this.csv.label[2]] = totalData.asap
        csvData[this.csv.label[3]] = totalData.web
        csvData[this.csv.label[4]] = totalData.admin
        csvData[this.csv.label[5]] = totalData.app
        csvData[this.csv.label[6]] = totalData.go
        csvData[this.csv.label[7]] = totalData.pax
        csvData[this.csv.label[8]] = totalData.avgPax
        csvData[this.csv.label[9]] = totalData.fare
        csvData[this.csv.label[10]] = totalData.avgFare
        csvData[this.csv.label[11]] = totalData.avgFarePP
        if (type === 'rsvpByDriver') {
          csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')'
          csvData[this.csv.label[1]] = totalData.distance
          csvData[this.csv.label[2]] = totalData.rsvp
          csvData[this.csv.label[3]] = totalData.asap
          csvData[this.csv.label[4]] = totalData.web
          csvData[this.csv.label[5]] = totalData.admin
          csvData[this.csv.label[6]] = totalData.app
          csvData[this.csv.label[7]] = totalData.go
          csvData[this.csv.label[8]] = totalData.pax
          csvData[this.csv.label[9]] = totalData.avgPax
          csvData[this.csv.label[10]] = totalData.fare
          csvData[this.csv.label[11]] = totalData.avgFare
          csvData[this.csv.label[12]] = totalData.avgFarePP
        }
        if ((['canceled', 'promo', 'noshow'].indexOf(this.selectedSummary) > -1 && type === 'rsvpSummary') || ['rsvpByDriverFare'].indexOf(type) > -1
        ) {
          csvData[this.csv.label[11]] = totalData.extraFee
        }
        if (['rsvpByDriverFare'].indexOf(type) > -1) {
          csvData[this.csv.label[9]] = totalData.dutyHours
          csvData[this.csv.label[10]] = totalData.fare
          csvData[this.csv.label[11]] = totalData.avgFare
          csvData[this.csv.label[12]] = totalData.avgFarePP
          csvData[this.csv.label[13]] = totalData.extraFee
          csvData[this.csv.label[14]] = totalData.percent
        }
        if (['rsvpByDriver'].indexOf(type) > -1) {
          csvData[this.csv.label[10]] = totalData.dutyHours
          csvData[this.csv.label[11]] = totalData.fare
          csvData[this.csv.label[12]] = totalData.avgFare
          csvData[this.csv.label[13]] = totalData.avgFarePP
          csvData[this.csv.label[14]] = totalData.extraFee
          csvData[this.csv.label[15]] = totalData.percent
        }
      }

      if (type === 'rsvpSummaryWeekly') {
        csvData[this.csv.label[0]] = 'Totals'

        var x = 1
        for (var i in this.csv.total) {
          csvData[this.csv.label[x]] = this.csv.total[i]
          x++
        }
      }

      if (type === 'rsvpByDate') {
        csvData[this.csv.label[0]] = ''
        csvData[this.csv.label[1]] = ''
        csvData[this.csv.label[2]] = ''
        csvData[this.csv.label[3]] = ''
        csvData[this.csv.label[4]] = ''
        csvData[this.csv.label[5]] = ''
        csvData[this.csv.label[6]] = 'Report Total ' + '(' + totalData.record + ')'
        csvData[this.csv.label[7]] = totalData.pax
        csvData[this.csv.label[8]] = totalData.fare
        if (['completed', 'canceled'].indexOf(this.selectedDetailed) === -1) {
          csvData[this.csv.label[9]] = ''
        }
        if (this.selectedDetailed === 'canceled') {
          csvData[this.csv.label[9]] = totalData.extraFee
        }
      }

      if (type === 'rsvpByRefund') {
        csvData[this.csv.label[0]] = ''
        csvData[this.csv.label[1]] = ''
        csvData[this.csv.label[2]] = ''
        csvData[this.csv.label[3]] = ''
        csvData[this.csv.label[4]] = ''
        csvData[this.csv.label[5]] = ''
        csvData[this.csv.label[6]] = ''
        csvData[this.csv.label[7]] = 'Report Total ' + '(' + totalData.record + ')'
        csvData[this.csv.label[8]] = totalData.pax
        csvData[this.csv.label[9]] = totalData.fare
        csvData[this.csv.label[10]] = totalData.refund
      }

      if (type === 'rsvpByAirport') {
        csvData[this.csv.label[0]] = 'Total ' + totalData.record
        csvData[this.csv.label[1]] = totalData.rsvp
        csvData[this.csv.label[2]] = totalData.asap
        csvData[this.csv.label[3]] = totalData.oneway
        csvData[this.csv.label[4]] = totalData.roundtrip
        csvData[this.csv.label[5]] = totalData.roundtripInstances
        csvData[this.csv.label[6]] = totalData.rsvpIsntances
        csvData[this.csv.label[7]] = totalData.onewayPercent + '%'
        csvData[this.csv.label[8]] = totalData.roundtripPercent + '%'
      }

      if (type === 'rsvpByAirportDepArr') {
        csvData[this.csv.label[0]] = 'Totals'
        csvData[this.csv.label[1]] = totalData.departureRsvp
        csvData[this.csv.label[2]] = totalData.arrivalRsvp
        csvData[this.csv.label[3]] = totalData.totalRsvp
        csvData[this.csv.label[4]] = totalData.departurePax
        csvData[this.csv.label[5]] = totalData.arrivalPax
        csvData[this.csv.label[6]] = totalData.totalPax
      }

      if (type === 'rsvpByPayment') {
        csvData[this.csv.label[0]] = 'Totals'
        csvData[this.csv.label[1]] = totalData.rsvp
        csvData[this.csv.label[2]] = totalData.pax
        csvData[this.csv.label[3]] = totalData.charged
        csvData[this.csv.label[4]] = totalData.gratuity
      }

      if (type === 'rsvpCorporate') {
        csvData[this.csv.label[0]] = ''
        csvData[this.csv.label[1]] = ''
        csvData[this.csv.label[2]] = ''
        csvData[this.csv.label[3]] = ''
        csvData[this.csv.label[4]] = ''
        csvData[this.csv.label[5]] = ''
        csvData[this.csv.label[6]] = ''
        csvData[this.csv.label[7]] = totalData.fare
      }

      if (type === 'rsvpTerminal') {
        csvData[this.csv.label[0]] = 'Totals'

        var x = 1
        for (var i in this.csv.total) {
          csvData[this.csv.label[x]] = this.csv.total[i]
          x++
        }
      }

      if (type === 'creditConverted') {
        csvData[this.csv.label[0]] = ''
        csvData[this.csv.label[1]] = ''
        csvData[this.csv.label[2]] = ''
        csvData[this.csv.label[3]] = ''
        csvData[this.csv.label[4]] = ''
        csvData[this.csv.label[5]] = ''
        csvData[this.csv.label[6]] = ''
        csvData[this.csv.label[7]] = totalData.pax
        csvData[this.csv.label[8]] = totalData.fare
        csvData[this.csv.label[9]] = totalData.creditReceived
      }

      return csvData
      // this.pdf.table.total
    },
    formatCheck () {
      this.error.show = false
      this.formatError = false
    },
    _serviceLabel (code) { return _services.getServiceName(code) },
    buildSectorData (data) {
      let self = this

      let grandTotal = {
        rsvp: 0,
        amount: 0,
        tnc: 0,
        tcp: 0
      }
      let grandTotalService = {
        tnc: {},
        tcp: {}
      }
      data.list.forEach((sector, sectorIndex) => {
        let totalRes = 0
        let totalAmount = 0
        let totalTnc = 0
        let totalTcp = 0
        if (sector.drivers && sector.drivers.tnc) {
          totalTnc = sector.drivers.tnc
        }
        if (sector.drivers && sector.drivers.tcp) {
          totalTcp = sector.drivers.tcp
        }
        sector.brands.forEach((brand, brandIndex) => {
          let brandRsvpTotal = 0
          let brandAmountTotal = 0
          brand.serviceTypes.forEach((service, serviceIndex) => {
            let tmpData = {
              'Sector Name': '',
              'Brand': '',
              'Service Type': '',
              'No of Reservation': '',
              'Total Reservation per Sector': '',
              'Total Amount per Service': '',
              'Total Amount per Sector': ''
            }
            if (brandIndex === 0 && serviceIndex === 0) tmpData['Sector Name'] = data.list[sectorIndex].name
            if (serviceIndex === 0) {
              tmpData['Brand'] = self.brandName(sector.brands[brandIndex])
            }

            tmpData['Service Type'] = service.label
            tmpData['No of Reservation'] = service.rsvps
            tmpData['Total Amount per Service'] = parseFloat(service.amount.toFixed(2))

            brandRsvpTotal += service.rsvps
            totalRes += service.rsvps
            brandAmountTotal += parseFloat(service.amount.toFixed(2))
            totalAmount += parseFloat(service.amount.toFixed(2))
            grandTotal.rsvp += service.rsvps
            grandTotal.amount += parseFloat(service.amount.toFixed(2))

            if (serviceIndex === sector.brands[brandIndex].serviceTypes.length - 1) {
              tmpData['Total Reservation per Sector'] = brandRsvpTotal
              tmpData['Total Amount per Sector'] = parseFloat(brandAmountTotal.toFixed(2))
            }

            let tmpType = ''
            if (service.tnc) tmpType = 'tnc'
            if (!service.tnc && service.tcp) tmpType = 'tcp'
            if (tmpType !== '' && !grandTotalService[tmpType][service.code]) {
              grandTotalService[tmpType][service.code] = {
                driver: 0,
                rsvp: 0,
                amount: 0,
                label: service.label
              }
            }
            grandTotalService[tmpType][service.code].rsvp += service.rsvps
            grandTotalService[tmpType][service.code].amount += parseFloat(service.amount.toFixed(2))

            self.csv.data.push(tmpData)
            if (brandIndex === sector.brands.length - 1 && serviceIndex === sector.brands[brandIndex].serviceTypes.length - 1) {
              self.csv.data.push({
                'Sector Name': 'TOTAL',
                'Brand': '',
                'Service Type': '',
                'No of Reservation': totalRes,
                'Total Reservation per Sector': totalRes,
                'Total Amount per Service': parseFloat(totalAmount.toFixed(2)),
                'Total Amount per Sector': parseFloat(totalAmount.toFixed(2))
              })
              self.csv.data.push({
                'Sector Name': `TOTAL TNC Drivers: ${totalTnc}`,
                'Brand': '',
                'Service Type': '',
                'No of Reservation': '',
                'Total Reservation per Sector': '',
                'Total Amount per Service': '',
                'Total Amount per Sector': ''
              })
              self.csv.data.push({
                'Sector Name': `TOTAL TCP Drivers: ${totalTcp}`,
                'Brand': '',
                'Service Type': '',
                'No of Reservation': '',
                'Total Reservation per Sector': '',
                'Total Amount per Service': '',
                'Total Amount per Sector': ''
              })
              grandTotal.tnc += totalTnc
              grandTotal.tcp += totalTcp
              self.csv.data.push({
                'Sector Name': '',
                'Brand': '',
                'Service Type': '',
                'No of Reservation': '',
                'Total Reservation per Sector': '',
                'Total Amount per Service': '',
                'Total Amount per Sector': ''
              })
            }
          })
        })
      })

      self.csv.data.push({
        'Sector Name': 'Grand Total',
        'Brand': '',
        'Service Type': '',
        'No of Reservation': grandTotal.rsvp,
        'Total Reservation per Sector': grandTotal.rsvp,
        'Total Amount per Service': parseFloat(grandTotal.amount.toFixed(2)),
        'Total Amount per Sector': parseFloat(grandTotal.amount.toFixed(2))
      })
      self.csv.data.push({
        'Sector Name': '',
        'Brand': '',
        'Service Type': '',
        'No of Reservation': '',
        'Total Reservation per Sector': '',
        'Total Amount per Service': '',
        'Total Amount per Sector': ''
      })
      self.csv.data.push({
        'Sector Name': 'SUMMARY',
        'Brand': '',
        'Service Type': '',
        'No of Reservation': '',
        'Total Reservation per Sector': '',
        'Total Amount per Service': '',
        'Total Amount per Sector': ''
      })
      self.csv.data.push({
        'Sector Name': `Total No of TNC: ${grandTotal.tnc}`,
        'Brand': '',
        'Service Type': '',
        'No of Reservation': '',
        'Total Reservation per Sector': '',
        'Total Amount per Service': '',
        'Total Amount per Sector': ''
      })
      self.csv.data.push({
        'Sector Name': `Total No of TCP: ${grandTotal.tcp}`,
        'Brand': '',
        'Service Type': '',
        'No of Reservation': '',
        'Total Reservation per Sector': '',
        'Total Amount per Service': '',
        'Total Amount per Sector': ''
      })
      self.csv.data.push({
        'Sector Name': '',
        'Brand': '',
        'Service Type': '',
        'No of Reservation': '',
        'Total Reservation per Sector': '',
        'Total Amount per Service': '',
        'Total Amount per Sector': ''
      })
      self.csv.data.push({
        'Sector Name': 'TNC:',
        'Brand': 'Drivers',
        'Service Type': 'No of Res',
        'No of Reservation': 'Revenue',
        'Total Reservation per Sector': '',
        'Total Amount per Service': '',
        'Total Amount per Sector': ''
      })
      for (var key in grandTotalService.tnc) {
        self.csv.data.push({
          'Sector Name': `${grandTotalService.tnc[key].label} (${key})`,
          'Brand': data.drivers.tnc[key] || 0,
          'Service Type': grandTotalService.tnc[key].rsvp,
          'No of Reservation': parseFloat(grandTotalService.tnc[key].amount.toFixed(2)),
          'Total Reservation per Sector': '',
          'Total Amount per Service': '',
          'Total Amount per Sector': ''
        })
      }
      self.csv.data.push({
        'Sector Name': '',
        'Brand': '',
        'Service Type': '',
        'No of Reservation': '',
        'Total Reservation per Sector': '',
        'Total Amount per Service': '',
        'Total Amount per Sector': ''
      })
      self.csv.data.push({
        'Sector Name': 'TCP:',
        'Brand': 'Drivers',
        'Service Type': 'No of Res',
        'No of Reservation': 'Revenue',
        'Total Reservation per Sector': '',
        'Total Amount per Service': '',
        'Total Amount per Sector': ''
      })
      for (var key in grandTotalService.tcp) {
        self.csv.data.push({
          'Sector Name': `${grandTotalService.tcp[key].label} (${key})`,
          'Brand': data.drivers.tcp[key] || 0,
          'Service Type': grandTotalService.tcp[key].rsvp,
          'No of Reservation': parseFloat(grandTotalService.tcp[key].amount.toFixed(2)),
          'Total Reservation per Sector': '',
          'Total Amount per Service': '',
          'Total Amount per Sector': ''
        })
      }

      console.log('@@',  grandTotalService)
      
      self.processDownloads('csv', {type: 'bySector'})
    },
    brandName (data) {
      let i = CONFIG.brands.findIndex(x => x.id === data.brandId)
      if (i === -1) { return data.code.toUpperCase() }

      return CONFIG.brands[i].name
    }
  },
  watch: {
    show (value) {
      if (!value) { return }

      this.from = null
      this.to = null
      this.error.show = false
      this.error.empty = []

      this.resetSelectedStatus()
      this.resetReportStatus()
    },
    dateType (value) {
      if (value === 'completeTime') {
        if (this.selectedReports.rsvpSummary && this.selectedSummary === 'canceled') {
          this.selectedSummary = 'all'
          this.selectedReports.rsvpSummary = false
        }
        if (this.selectedReports.rsvpByDate && this.selectedDetailed === 'canceled') {
          this.selectedDetailed = 'all'
          this.selectedReports.rsvpByDate = false
        }
      } else if (value === 'cancelTime') {
        if (this.selectedReports.rsvpSummary && this.selectedSummary === 'completed') {
          this.selectedSummary = 'all'
          this.selectedReports.rsvpSummary = false
        }
        if (this.selectedReports.rsvpByDate && this.selectedDetailed === 'completed') {
          this.selectedDetailed = 'all'
          this.selectedReports.rsvpByDate = false
        }
      }
    },
    from (value) { this.resetReportStatus() },
    to (value) { this.resetReportStatus() },
    'selectedReports.rsvpSummary' (value) { this.resetReportStatus() },
    'selectedReports.rsvpSummaryWeekly' (value) { this.resetReportStatus() },
    'selectedReports.rsvpByDate' (value) { this.resetReportStatus() },
    'selectedReports.rsvpByRefund' (value) { this.resetReportStatus() },
    'selectedReports.rsvpByDriver' (value) { this.resetReportStatus() },
    'selectedReports.rsvpByDriverFare' (value) { this.resetReportStatus() },
    'selectedReports.rsvpByServiceType' (value) { this.resetReportStatus() },
    'selectedReports.rsvpByAirport' (value) { this.resetReportStatus() },
    'selectedReports.rsvpByAirportDepArr' (value) { this.resetReportStatus() },
    'selectedReports.rsvpByGroup' (value) { this.resetReportStatus() },
    'selectedReports.rsvpByPayment' (value) { this.resetReportStatus() },
    'selectedReports.rsvpByTripStatus' (value) { this.resetReportStatus() },
    'selectedReports.rsvpByBrands' (value) { this.resetReportStatus() },
    'selectedReports.rsvpSummaryCorporate' (value) { this.resetReportStatus() },
    'selectedReports.rsvpCorporate' (value) { this.resetReportStatus() },
    'selectedReports.rsvpTerminal' (value) { this.resetReportStatus() },
    'selectedReports.creditConverted' (value) { this.resetReportStatus() },
    'selectedReports.bySector' (value) { this.resetReportStatus() }
  }
}
</script>

<style lang="scss" scoped>
.rsvp-report-box {
  transform-origin: top center;
  position: relative;
  width: 100%;

  &.slide-down-leave-active, &.slide-down-enter-active{ overflow: hidden; }
}
.rsvp-report {
  border-radius: 3px;
  padding: 0 20px 20px;

  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 20px;
    font-size: 18px;
  }

  & .date-input {
    margin-bottom: 10px;

    & label {
      font-size: 13px;
      color: #999;
      display: block;
    }
    select{
      padding: 10px;
      height: 46px;
      outline: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border-color: #cacaca;
      font-size: 14px;
      color: #333;
      background-image: url('/assets/img/dropdown-arrow.png');
      background-repeat: no-repeat;
      background-position: right 50%;

      &[disabled]{ background-color: #ebebe4; }
    }
  }

  .reports{
    max-height: 350px;
    margin-bottom: 10px;
    clear: both;
    overflow: auto;
    background: #fafafa;
    border: 1px solid #ddd;
    position: relative;

    .report{
      position: relative;
      z-index: 1;

      &:hover{ background:#f1f1f1; }
      &.processing{
        background: rgba(0,0,0, .7);
        input{ opacity: .5; }
      }
      select{
        margin-left: 28px;
        margin-bottom: 10px;
        width: calc(100% - 43px);
        border-color: #999;
        font-size: 13px;
        color: #333;
        padding: 3px 5px;
        transition: all .2s ease;

        &.disabled{
          background: #fafafa;
          border-color: #ccc;
        }
        option:disabled{ background: #eaeaea; }
      }
      &.on-queue, &.loading, &.has-error, &.success{
        z-index: 3;
        box-shadow: 0 0 2px rgba(0,0,0, .4);
      }
      &.on-queue{ background: #fff; }
      &.loading{
        color: #775913;
        background: #f1ce7e;
      }
      &.success{
        color: #0f693a;
        background: #a9f7ce;
      }
      &.has-error{
        color: #b93030;
        background: #fbb0b0;
      }
    }
  }
}

.download-type{
  float: right;
  width: 150px;
  text-align: right;
  padding-bottom: 5px;


  label{
    cursor: pointer;
    display: inline-block;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    padding: 2px 7px;
    border:1px solid #ddd;

    &.pdf{ color: #c54d4d; }
    &.csv{ color: #7ad275; }
    &.has-error{ border: 1px solid #d00; }
    input{
      display: inline;
      margin-top: 0;
      width: auto;
      vertical-align: -1px;
    }
  }
}

.list-box{
  overflow: hidden;
  position: relative;
  padding-bottom: 20px;
}

.error {
  background-color: #F25E0D;
  font-size: 14px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 15px;
  transform-origin: top center;

  ul{
    list-style: none;
    margin: 0;
    padding: 10px;
    text-align: left;

    li:first-child{
      font-weight: 600;
      font-size: 14px;
      line-height: 1;
      margin-bottom: 2px;
    }
    li{
      font-size: 13px;
    }
  }
}

.form-group {
  display: block;

  & .instruction {
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 600;
    color: #777;
  }
}

.checkbox {
  display: block;
  font-size: 13px;
  cursor: pointer;
  padding: 5px 10px;
  & > * {
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    width: auto;
  }
  input { margin-right: 3px; }
}
.padding-R { padding-right: 7px; }
.padding-L { padding-left: 7px; }

#pdf-view{
  position: fixed;
  top: 0%;
  right: 100%;
  width: 793px;
  height: 1122px;
  background: #fff;
  z-index: -1;

  .page{
    padding: 30px;
    position: relative;
    width: 100%;
    height: 100%;

    .page-count{
      position: absolute;
      bottom: 10px;
      right: 30px;
      color: #aaa;
      font-size: 12px;
      text-align: right;
      font-style: italic;
    }
  }
  .title{
    text-align: center;
    font-weight: 600;
    font-size: 21px;
  }
  .date-range{
    text-align: center;
    font-style: italic;
    font-size: 18px;
    margin-bottom: 20px;
    color: #555;
  }

  table{
    width: 100%;
    font-size: 12px;
    border-collapse: collapse;

    thead{
      font-weight: 600;
      tr:last-child th{ border-bottom: 1px solid #333; }
    }
    tbody{
      tr{
        &.subtotal, &.total{ font-weight: 700; }
        &.total{
          color: #000;
          font-size: 15px;
        }
      }
      td{ padding: 2px 3px; }
    }
  }
}

.rsvp-by-date, .rsvp-by-refund{
  width: 1122px!important;
  height: 793px!important;

  table{
    tbody{
      tr.subtotal{ border-top: 1px solid #333; }
      .name{ max-width: 120px; }
      .service{ max-width: 90px; }
      .pickupLocation, .dropoffLocation{ max-width: 200px; }
      .name, .service, .pickupLocation, .dropoffLocation{
        max-width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .source, .direction, .service, .pickupTime, .refundedDate, .pickupLocation, .dropoffLocation,
    .pax, .status, .total-pax, .flight, .flightType{ text-align: center; }
    .pickupTime, .refundedDate{ width: 120px; }
    .pax{ width: 70px; }
    .fare, .total-count, .total-fare, .refundAmount, .total-refund,
    .extraFee{ text-align: right; }
    .total-count{ padding-right: 10px; }
  }
}
.rsvp-by-date{
  table tbody{
    .name, .pickupTime, .pax, .flight, .flightType{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .pickupLocation, .dropoffLocation{ max-width: 170px; }
    .name { max-width: 155px; }
    .pickupTime{ max-width: 130px; }
    .pax{ max-width: 60px; }
    .flight{ max-width: 70px; }
    .flightType{ max-width: 60px; }
  }
}
.rsvp-by-refund{
  table{
    tbody{
      .name{
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .service{ width: 90px; }
      .pickupTime, .refundedDate{ font-size: 11px; }
      .pickupLocation, .dropoffLocation{ max-width: 170px; }
    }
  }
}
.rsvp-summary, .driver-rsvp, .service-rsvp, .promo-rsvp, .status-rsvp, .brands-rsvp, .summary-corporate-rsvp, .corporate-rsvp, .credit-converted{
  width: 1122px!important;
  height: 793px!important;
  table{
    tbody tr.total{ border-top: 1px solid #333; }
    .date, .rsvpCount, .distance, .asap, .web, .admin, .app, .go, .totalPax, .avgPax, .dutyHours{ text-align: center; }
    .totalFare, .avgFare, .avgFarePP, .extraFee, .driverPayment, .driverPercent{ text-align: right; }
    .driver, .service, .promo{
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.airport-rsvp{
  table{
    tbody tr.total{ border-top: 1px solid #333; }
    .rsvpCount, .asap, .oneway, .roundtrip{ text-align: center; }
    .roundtripInstances, .totalRsvpInstances, .onewayPercent,
    .roundtripPercent{ text-align: right; }
  }
}
.weekly-summary{
  .table-heading{ line-height: 1.2; }
  .time{ width: 100px; }
  table td{ text-align: center; }
  tr.total{ border-top: 1px solid #333; }
}
.airport-rsvp-deparr{
  table{
    tr.total{ border-top: 1px solid #333; }
    tr td{ text-align: center; }
  }
}
.variance-table{
  width: 1122px!important;
  height: 793px!important;

  table{
    .pickupTime, .pax, .paymentType{ text-align: center; }
    .fare, .cash, .cc, .db, .check, .other, .variance{ text-align: right; }
  }
}
.payment-rsvp{
  table{
    tr.total{ border-top: 1px solid #333; }
    .total-label, .rsvp, .pax{ text-align: center; }
    .charged, .gratuity{ text-align: right; }
  }
}
.trx-summary{
  height: 1122px!important;
  width: 793px!important;
  table{
    tbody tr.total{ border-top: 1px solid #333; }
    .date, .rsvpCount, .trxCount, .purchaseCount, .additionalCount,
    .chargedTrxCount, .refundTrxCount{ text-align: center; }
    .totalCharges, .chargedAmount, .refundAmount, .netTotal{ text-align: right; }
  }
}
.trx-detailed{
  height: 1122px!important;
  width: 793px!important;
  table{
    tbody tr.total{ border-top: 1px solid #333; }
    .date, .rsvpId, .invoiceId, .customer, .cardOwner, .transactionType{ text-align: center; }
    .chargedAmount, .refundAmount{ text-align: right; }
    .transactionType{ text-transform: capitalize; }
  }
}
.corporate-rsvp{
  table{
    tbody td{ padding: 2px 5px!important; }
    .rsvpId, .corporate, .guest, .service, .pickupTime, .fare{ text-align: center; }
    .pickupLocation{ padding-right: 5px!important; }
    .dropoffLocation{ padding-left: 5px!important; }
    .pickupLocation, .dropoffLocation{
      width: 205px;
      max-width: 210px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.rsvp-terminal{
  .table-heading{ line-height: 1.2; }
  th{ padding-bottom: 5px; }
  .time{ width: 100px; }
  table td{ text-align: center; }
  tbody {
    tr{
      border: 1px solid #eee;
      border-left-color: transparent;
      border-right-color: transparent;
      border-bottom-color: transparent;
    }
    td{ line-height: 1.5; }
  }
  tr.total{
    border-top: 1px solid #333;
  }
}
.credit-converted{
  .rsvpId, .brand, .pickupTime, .pickup, .dropoff, .service, .pax, .source, .total-pax{ text-align: center; }
  .fare, .creditReceived, .total-fare, .total-creditReceived{ text-align: right; }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .rsvp-report {
    .form-group .row.expanded.filter-date {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 1em;

      .select-date {
        grid-column-start: 1;
        grid-column-end: 3;
      }

      .small-4 {
        padding: 0;
        width: 100%;
      }

      .end-date {
        /deep/ .vdp-datepicker__calendar {
          right: 1px;
        }
      }
    }

    .reports .report {
      padding: 2px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/RsvpReport.vue